import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, OnDestroy, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { ResumenTareasService } from 'src/app/services/resumen-tareas.service';
import * as XLSX from 'xlsx';
import * as FileSaver from 'file-saver';
import { MatDialog, MatPaginator, MatTableDataSource } from '@angular/material';
import { ToastrManager } from 'ng6-toastr-notifications';
import { Subscription, timer } from 'rxjs';
import { CdkDragDrop, moveItemInArray, transferArrayItem } from '@angular/cdk/drag-drop';
import { DialogGeoDetelle } from './dialogGeoDetelle/dialogGeoDetelle.component';
import { DireccionNormalizada, GeolocationManagerService, PuntoConOrden } from 'src/app/core/services/geolocation-manager.service';
import { MapsAPILoader } from '@agm/core';
declare var google: any; // Declara la variable global de Google Maps
var negocio: any;
var agencia: any;
import html2canvas from 'html2canvas';


export interface IntentoOptimizacion {
  intento: number;
  fechaFinAjustada: string;
  resultado: any;
  exito: boolean;
}
export interface Location {
  id: number;
  latitude: number;
  longitude: number;
}

export interface GeoZone {
  id: number;
  locations: Location[];
}


interface Visit {
  isPickup: boolean;
  startTime: string;
  detour: number;
  nombreRuta: String
}

interface Transition {
  travelDuration: string;
  travelDistanceMeters: number;
  waitDuration: string;
  totalDuration: string;
  startTime: string;
}

interface Metrics {
  performedShipmentCount: number;
  travelDuration: string;
  waitDuration: string;
  delayDuration: string;
  breakDuration: string;
  visitDuration: string;
  totalDuration: string;
  travelDistanceMeters: number;
}

interface Route {
  vehicleStartTime: string;
  vehicleEndTime: string;
  visits: Visit[];
  transitions: Transition[];
  metrics: Metrics;
  routeCosts: number[];
  routeTotalCost: number;


}

interface Response {
  routes: Route[];
}

const municipiosCercanosTop5 = [
  'Bello',
  'Itaguí',
  'Envigado',
  'Sabaneta',
  'Copacabana'
];


const mapeoCampos: { [key: string]: string } = {
  // Dirección / Address
  'direccion': 'Address',
  'dir': 'Address',
  'address': 'Address',
  'ubicacion': 'Address',

  // Documento / Document
  'documento': 'Document',
  'doc': 'Document',
  'Documento':'Document',
  'document': 'Document',
  'id': 'Document',
  'identificacion': 'Document',

  // Nombre
  'nombre': 'Client',
  'name': 'Client',
  'Name': 'Client',


  // Teléfono
  'telefono': 'Phone',
  'numero contacto': 'Phone',
  'phone': 'Phone',

  // Email
  'email': 'Email',
  'correo': 'Email',

  // Otros
  'pedido': 'visitLabel',
  'unidades': 'unit',
  'importe': 'Importe',
  'peso total (kg)': 'Payload',
  'cliente': 'Client',
  'Cliente': 'Client',
  'Latitud': 'Latitud',
  'latitud': 'Latitud',
  'longitud': 'Longitud',
  'longitude': 'Longitud',
  'latitude': 'Latitud',
  'Longitude': 'Longitud',
  'Latitude': 'Latitud',


};

const parseSafe = (value: any): number | null => {
  if (value === null || value === undefined) return null;
  const num = typeof value === 'string' ? parseFloat(value) : Number(value);
  return isNaN(num) ? null : num;
};


@Component({
  selector: 'app-fragmentMapaGeneralRuteo',
  templateUrl: './fragmentMapaGeneralRuteo.component.html', // Usa solo templateUrl
  styleUrls: ['./fragmentMapaGeneralRuteo.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class FragmentMapaGeneralRuteo implements OnInit, OnDestroy, AfterViewInit {

  @ViewChild('mapContainer', { static: false }) mapContainer!: ElementRef;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  fechaInicio: string = new Date().toISOString().split('T')[0]; // Fecha actual

  private intervalo: any;
  private ultimaUbicacionlista: any[] = []
  private response: any; // Almacena la respuesta de la API
  private routes: any[] = []; // Almacena las rutas procesadas
  private iscargado = false;
  private mergedData: any[] = []; // Almacena las rutas procesadas
  private seleccionarTodos: boolean = true; // No selecciona todos al inicio
  private usuarioSeleccionado: any = null;
  private token: string = "";
  private intentosOptimizacion: IntentoOptimizacion[] = [];
  private maxIntentos: number = 5;
  private intentoActual: number = 0;
  private esquemas: any[] = []
  private esquemasView: any[] = []
  private listaConGeo: any[] = []
  private isPrintinginProgress = true
  private subscription!: Subscription;
  private isRecarga = false
  private vehiclesesquemaview: any[] = []
  private vehiclesesquemaviewSelecciona: any[] = []
  private visitsFromResponse: any[] = []
  private updatedVehiclesList: any[] = [];
  private resultadoVRT: any
  private result: any;
  private geosincronizar: any;
  private isValidadorGeo = true
  private esquemaSeleccionado: any;
  private error: any;
  private tableData: any[] = [];
  private data: any[] = [];
  private dataOrignal: any[] = [];
  private dataZonas: any[] = [];

  private criterioReabastecimiento: string = 'paquete'; // Valor por defecto
  // En tu componente
  private mostrarRecursos: boolean = false;
  private fileName: string = '';
  private errorArchivo: string = '';
  private displayedColumns: string[] = [
    'visitLabel', 'Name',
    'Address', 'Latitude', 'Longitude', 'ServiceDuration',
    'StartTime', 'EndTime', 'Q1', 'Q2', 'SKILL'
  ];


  private dataSource = new MatTableDataSource();
  private permitirReabastecimiento: boolean = false; // Desactivado por defecto

  private tiposOptimizacion = [
    { id: 'min-total-travel-duration', nombre: 'Minimizar Tiempo Total' },
    { id: 'min-schedule-completion-time', nombre: 'Minimizar Itinerario Más Largo' }
  ];

  private tipoOptimizacionSeleccionado = this.tiposOptimizacion[0].id; // Opción por defecto
  totalDirecciones: number = 0;
  porcentajeVerificadas: number = 0;
  verificadas100: number = 0;  // 100% verificadas
  verificadas70: number = 0;   // 70-99% verificadas
  verificadas50: number = 0;   // 50-69% verificadas
  verificadas0: number = 0;    // 0-49% verificadas
  constructor(private mapsAPILoader: MapsAPILoader, private geoManager: GeolocationManagerService, private cdr: ChangeDetectorRef, private resumenService: ResumenTareasService, public toastr: ToastrManager, public dialogagregar: MatDialog) {

  }



  toggleRecursos() {
    this.mostrarRecursos = !this.mostrarRecursos;
  }

  eliminarArchivo(event: Event): void {
    event.stopPropagation();
    this.fileName = '';
    this.errorArchivo = '';
    this.data = []; // Limpiar datos si es necesario
    // Puedes agregar aquí cualquier otra limpieza necesaria
  }

  // Método auxiliar para resetear el input
  private resetFileInput(input: HTMLInputElement): void {
    input.value = '';
    this.fileName = '';
  }

  // Mantener tu función existente
  agruparRecursos(recursos: any[], itemsPorFila: number): any[] {
    const grupos = [];
    for (let i = 0; i < recursos.length; i += itemsPorFila) {
      grupos.push(recursos.slice(i, i + itemsPorFila));
    }
    return grupos;
  }


  onpermitirReabastecimiento() {
    console.log('permitirReabastecimiento seleccionado:', this.permitirReabastecimiento);
    // Aquí puedes agregar lógica adicional cuando cambia la selección
  }
  onTipoDeOptimizacion() {
    console.log('tipoOptimizacionSeleccionado seleccionado:', this.tipoOptimizacionSeleccionado);
    // Aquí puedes agregar lógica adicional cuando cambia la selección
  }

  onCriterioChange() {
    console.log('Criterio seleccionado:', this.criterioReabastecimiento);
    // Aquí puedes agregar lógica adicional cuando cambia la selección
  }

  // Método para manejar el cambio de archivo
  onFileChange(event: any): void {
    const target: DataTransfer = <DataTransfer>(event.target);
    const file: File = target.files[0];

    // Resetear mensajes de error
    this.errorArchivo = '';

    // Validaciones básicas
    if (!file) {
      return;
    }

    if (file.size > 5 * 1024 * 1024) { // 5MB máximo
      this.errorArchivo = 'El archivo es demasiado grande (máx. 5MB)';
      this.resetFileInput(event.target);
      return;
    }

    if (!['application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'].includes(file.type)) {
      this.errorArchivo = 'Formato de archivo no válido';
      this.resetFileInput(event.target);
      return;
    }

    // Procesar el archivo
    this.fileName = file.name;
    const reader: FileReader = new FileReader();

    reader.onload = (e: any) => {
      try {
        const bstr: string = e.target.result;
        const wb: XLSX.WorkBook = XLSX.read(bstr, { type: 'binary' });
        const wsname: string = wb.SheetNames[0];
        const ws: XLSX.WorkSheet = wb.Sheets[wsname];

        // Obtener los datos crudos
        const rawData = XLSX.utils.sheet_to_json(ws);
        console.log('original', rawData);
        // Normalizar los campos
        this.data = this.normalizarCampos(rawData);

        console.log('Normalizada', this.data);
        this.dataOrignal = this.data;
        this.isPrintinginProgress = false;
        this.totalDirecciones = this.data.length;
        //this.procesarTareas();

      } catch (error) {
        console.error('Error al procesar el archivo:', error);
        this.errorArchivo = 'Error al leer el archivo';
        this.resetFileInput(event.target);
      }
    };

    reader.onerror = () => {
      this.errorArchivo = 'Error al leer el archivo';
      this.resetFileInput(event.target);
    };

    reader.readAsBinaryString(file);
  }

  /**
   * Normaliza los nombres de campos en un arreglo de objetos según un mapeo predefinido.
   * Soporta diferencias en mayúsculas, acentos y variaciones comunes.
   */
  normalizarCampos(data: any[]): any[] {
    if (!Array.isArray(data) || data.length === 0) return [];



    const limpiarClave = (clave: string): string =>
      clave
        .toLowerCase()
        .normalize("NFD") // quita acentos
        .replace(/[\u0300-\u036f]/g, "")
        .replace(/\s+/g, ' ') // normaliza espacios internos
        .trim(); // elimina espacios al inicio/fin

    return data.map(item => {
      const nuevoItem: any = {};

      for (const key in item) {
        if (item.hasOwnProperty(key)) {
          const claveLimpia = limpiarClave(key);
          const claveNormalizada = mapeoCampos[claveLimpia] || key;
          nuevoItem[claveNormalizada] = item[key];
        }
      }

      return nuevoItem;
    });
  }



  



  async procesarItemHistorial(item: any): Promise<{
    tareasHistoricas: any[],
    direccionValidada: string,
    coordenadas: { lat: number, lng: number },
    googleData: any,
    hereData: any,
    isPlace:boolean,
    findClosestBusinessByName: any,
    allComponentsConfirmed: boolean,
    isDistanceGreater: boolean,
    validateDistance: number,
    recomendaciones: {
      usarDireccionGoogle: boolean,
      distanciaValidacion: number
    }
  }> {
    try {
      // ==================== PASO 1: OBTENER DATOS INICIALES ====================
      const { fechaActual, fechaDosMesesAtras } = this.geoManager.obtenerFechas();
      const negocio = localStorage.getItem("negocio");
      const agencia = localStorage.getItem("agencia");

      // ==================== PASO 2: OBTENER TAREAS HISTÓRICAS ====================
      const tareasHistoricas = await this.obtenerTareasHistoricas(
        negocio,
        agencia,
        item.Address,
        fechaDosMesesAtras,
        fechaActual
      );
      console.log("VRTIA 1 - Tareas históricas obtenidas:", tareasHistoricas);

      // ==================== PASO 3: PROCESAR DIRECCIÓN Y ZONA ====================
      const direccionFinal = this.geoManager.obtenerDireccionMasCercana(tareasHistoricas);
      console.log("VRTIA 2 - Dirección final seleccionada:", direccionFinal);

      const direccionZona = this.geoManager.obtenerZonaDesdeDireccion(direccionFinal.direccion, direccionFinal.enSitio);


      this.geoManager.agregarZonaUnica(direccionZona, this.dataZonas);
      console.log("VRTIA 3 - Zonas actualizadas:", this.dataZonas);

      const direccionLimpia = item.VRTIA_AddressNormalized;
      item.VRTIA_AddressInit = `${direccionLimpia} ${direccionZona}`;
      console.log("VRTIA 4 - Dirección inicial limpia:", item.VRTIA_AddressInit);

      // ==================== PASO 4: VALIDACIÓN CON GOOGLE ====================
      const topMunicipios = ['Antioquia Medellín', 'Antioquia Bello', 'Antioquia Envigado', 'Antioquia Itagüí', 'Antioquia Sabaneta', 'Antioquia Copacabana'];

      let mejorDireccion: string | null = null;
      let mejorGoogleData: any = null;
      let mejorConfirmacion = false;
      interface DireccionValidada {
        municipio: string;
        direccion: string;
        formattedAddress: string;
        googleData: any;
      }

      const direccionesValidas: DireccionValidada[] = [];
      if (item.VRTIA_WEB_direccion){
        console.log("VRTIA antes del pusd");
        try {
          const googleData = await this.resumenService.validateAddress(item.VRTIA_WEB_direccion, "", "CO").toPromise();
          console.log(`✅ Componentes googleData para ${item.VRTIA_WEB_direccion}:`, googleData);
          const allComponentsConfirmed = this.areAllAddressComponentsConfirmed(googleData);

          console.log(`✅ Componentes confirmados para ${item.VRTIA_WEB_direccion}:`, allComponentsConfirmed);
          const direccion = `${item.VRTIA_WEB_direccion} `;
          const municipio = ``;
          // Guardar si es el primero confirmado o el mejor encontrado
          if (item.VRTIA_WEB_direccion) {
            mejorDireccion = item.VRTIA_WEB_direccion;
            mejorGoogleData = googleData;
            mejorConfirmacion = true;

            const formattedAddress = googleData.result.address.formattedAddress;
            console.log("VRTIA antes del pusd");
            if (item.VRTIA_WEB_direccion){
              console.log("VRTIA antes del ingresa");
              direccionesValidas.push({
                direccion,
                municipio,
                formattedAddress,
                googleData
              });

              console.log("VRTIA antes del ingrsalioesa direccionesValidas", direccionesValidas);
            }
            console.log("VRTIA antes del ingrsalioesa");

          }

          // Si ninguno confirmado aún, tomar el primero como "menos malo"
          if (!mejorGoogleData) {
            mejorDireccion = item.VRTIA_WEB_direccion;
            mejorGoogleData = googleData;
          }

        } catch (err) {
          console.error(`❌ Error validando dirección con ${   item.VRTIA_WEB_direccion}:`, err);
        }
       }else{
      
        for (const municipio of topMunicipios) {
          const direccion = `${item.Address} ${municipio}`;
          console.log(`🔍 Probando con: ${direccion}`);
  
          try {
            const googleData = await this.resumenService.validateAddress(direccion, "", "CO").toPromise();
            console.log(`✅ Componentes googleData para ${municipio}:`, googleData);
            const allComponentsConfirmed = this.areAllAddressComponentsConfirmed(googleData);
  
            console.log(`✅ Componentes confirmados para ${municipio}:`, allComponentsConfirmed);
  
            // Guardar si es el primero confirmado o el mejor encontrado
            if (allComponentsConfirmed) {
              mejorDireccion = direccion;
              mejorGoogleData = googleData;
              mejorConfirmacion = true;
  
              const formattedAddress = googleData.result.address.formattedAddress;
  
              direccionesValidas.push({
                municipio,
                direccion,
                formattedAddress,
                googleData
              });
  
            }
  
            // Si ninguno confirmado aún, tomar el primero como "menos malo"
            if (!mejorGoogleData) {
              mejorDireccion = direccion;
              mejorGoogleData = googleData;
            }
  
          } catch (err) {
            console.error(`❌ Error validando dirección con ${municipio}:`, err);
          }
        }
       }

     

      // Al final, ya tienes la mejor dirección encontrada
      if (mejorGoogleData) {
        const formattedAddress = mejorConfirmacion
          ? mejorGoogleData.result.address.formattedAddress
          : item.Address;

        const validateDistance = mejorConfirmacion ? 150 : 50;

        console.log("🎯 Dirección final usada:", mejorDireccion);
        console.log("📌 Formatted Address:", formattedAddress);
        console.log("📏 Distancia de validación:", validateDistance);
      }

      console.log("📋 Lista de direcciones validadas:", direccionesValidas);

      let mejoresCoincidencias: {
        direccion: DireccionValidada;
        resultado: { place: any | null; matchScore: number; };
      }[] = [];

       
      for (const direccion of direccionesValidas) {
        const location = direccion.googleData.result.geocode.location;
        const lat = location.latitude;
        const lng = location.longitude;

        try {
          console.log(`🔍 ingreso por aca lo esperado `);
          if(item.VRTIA_WEB_cidCoincidente){
            var nombre  =   item.Client
            if(item.VRTIA_WEB_tituloCoincidente){
              nombre = item.VRTIA_WEB_tituloCoincidente
            } else{
              if(item.VRTIA_WEB_marcaComercial){
                nombre = item.VRTIA_WEB_marcaComercial
              } 
            } 

        
            const searchPlacesRaw = await this.resumenService.searchPlacesDetails(item.VRTIA_WEB_marcaComercial + " "+ item.VRTIA_WEB_direccion).toPromise();
            console.log(`🔍 Resultado en searchPlacesRaw `, searchPlacesRaw);

            console.log(`🔍 Resultado en nombresssss direccionnnn ${direccion}:`, direccion);
            console.log(`🔍 Resultado en nombresssss ${direccion.municipio}:`, nombre);
            const resultado = this.geoManager.findClosestBusinessByNameVici(
              nombre,
              item.VRTIA_WEB_direccion,
              searchPlacesRaw.results
            );
  
            console.log(`🔍 Resultado en ${direccion.municipio}:`, resultado);
  
            // Solo guardar si el matchScore es mayor a 0
            if (resultado.matchScore > 0) {
              mejoresCoincidencias.push({
                direccion,
                resultado
              });
            }



          }else{

            var nombre  =   item.Client
            if(item.VRTIA_WEB_marcaComercial){
              nombre = item.VRTIA_WEB_marcaComercial
            } 
            const searchPlacesRaw = await this.resumenService.searchPlacesRaw(
              lat,
              lng,
              50,
              ""
            ).toPromise();
            const resultado = this.geoManager.findClosestBusinessByName(
              nombre,
              item.VRTIA_WEB_direccion,
              searchPlacesRaw.results
            );
  
            console.log(`🔍 Resultado en ${direccion.municipio}:`, resultado);
  
            // Solo guardar si el matchScore es mayor a 0
            if (resultado.matchScore > 0) {
              mejoresCoincidencias.push({
                direccion,
                resultado
              });
            }
          } 
     

        } catch (err) {
          console.error(`❌ Error en búsqueda para ${direccion.direccion}:`, err);
        }
      }

      let mejorCoincidenci = null;

      if (mejoresCoincidencias.length > 0) {
        mejorCoincidenci = mejoresCoincidencias.reduce((prev, current) =>
          current.resultado.matchScore > prev.resultado.matchScore ? current : prev
        );

        console.log("🏆 Mejor coincidencia encontrada:");
        console.log("googleData:", mejorCoincidenci.direccion.googleData);
        console.log("Dirección:", mejorCoincidenci.direccion.formattedAddress);
        console.log("Lugar:", mejorCoincidenci.resultado.place);
        console.log("Puntaje:", mejorCoincidenci.resultado.matchScore);


        findClosestBusinessByName = mejorCoincidenci.resultado
        let googleData = mejorCoincidenci.direccion.googleData

        console.log("VRTIA 5 - Datos de Google:", googleData);

        let allComponentsConfirmed = this.areAllAddressComponentsConfirmed(googleData);
        let validateDistance = allComponentsConfirmed ? 50 : 150;
        let formattedAddress = allComponentsConfirmed
          ? googleData.result.address.formattedAddress
          : direccionLimpia;
        console.log("VRTIA 6 - Componentes confirmados:", allComponentsConfirmed);
        console.log("VRTIA 6.1 - formattedAddress:", allComponentsConfirmed);




        // Asignación de valores a item
        item.VRTIA_AllComponentsConfirmed = allComponentsConfirmed;
        item.VRTIA_FormattedAddress = formattedAddress;
        item.VRTIA_ValidateDistance = validateDistance;

        let googlePosition = googleData.result.geocode.location;
        item.VRTIA_Google_Latitud = googlePosition.latitude;
        item.VRTIA_Google_Longitud = googlePosition.longitude;


        // ==================== PASO 5: CÁLCULO DE DISTANCIAS ====================
        const distanceBetweenReportAndGoogle = this.geoManager.calcularDistanciaEnMetros(
          googlePosition.latitude,
          googlePosition.longitude,
          direccionFinal.latitud,
          direccionFinal.longitud
        );
        item.VRTIA_DistanceBetweenReportAndGoogle = distanceBetweenReportAndGoogle;
        console.log("VRTIA 7 - Distancia reporte-Google:", distanceBetweenReportAndGoogle);

        let distanceBetweenSentPointAndGoogle: number | null = null;
        const lat1 = googlePosition.latitude;
        const lon1 = googlePosition.longitude;
        const lat2 = parseFloat(item.Latitud);
        const lon2 = parseFloat(item.Longitud);

        if (typeof lat1 === 'number' && typeof lon1 === 'number' && !isNaN(lat2) && !isNaN(lon2)) {
          distanceBetweenSentPointAndGoogle = this.geoManager.calcularDistanciaEnMetros(lat1, lon1, lat2, lon2);
        }
        item.VRTIA_DistanceBetweenSentPointAndGoogle = distanceBetweenSentPointAndGoogle;
        console.log("VRTIA 8 - Distancia punto enviado-Google:", distanceBetweenSentPointAndGoogle);

        var getFormattedAddress = this.geoManager.getFormattedAddress(googleData, true).replace(/[#,]/g, ' ');
        console.log("VRTIA 8.1 - reporte-getFormattedAddress:", this.geoManager.limpiarDireccion(getFormattedAddress).replace(/[#,]/g, ' '));


        item.VRTIA_AddressLabelGoogle = this.geoManager.limpiarDireccion(getFormattedAddress).replace(/[#,]/g, ' ')
        // ==================== PASO 6: VALIDACIÓN CON HERE ====================
        let hereData = await this.resumenService.getCoordinates(item.VRTIA_AddressLabelGoogle).toPromise();
        console.log("VRTIA 8.2 - reporte-HERE:", hereData);
        let herePosition = hereData.items[0].position;
        let hereAddress = hereData.items[0].address;

        //nuevo inicio

        const distanceBetweenReportAndHere = this.geoManager.calcularDistanciaEnMetros(
          herePosition.lat,
          herePosition.lng,
          direccionFinal.latitud,
          direccionFinal.longitud
        );
        item.VRTIA_DistanceBetweenReportAndHere = distanceBetweenReportAndHere;
        console.log("VRTIA 9 - Distancia reporte-HERE:", distanceBetweenReportAndHere);

        let distanceBetweenSentPointAndHere: number | null = null;
        const lat1h = herePosition.lat;
        const lon1h = herePosition.lng;
        const lat2h = googlePosition.latitude;
        const lon2h = googlePosition.longitude;

        if (typeof lat1 === 'number' && typeof lon1 === 'number' && !isNaN(lat2) && !isNaN(lon2)) {
          distanceBetweenSentPointAndHere = this.geoManager.calcularDistanciaEnMetros(lat1h, lon1h, lat2h, lon2h);
        }
        console.log("VRTIA 10 - Distancia punto enviado-HERE:", distanceBetweenSentPointAndHere);
        item.VRTIA_DistanceBetweenSentPointAndHere = distanceBetweenSentPointAndHere;

        // Procesamiento de direcciones HERE
        item.VRTIA_AddressLabelHere = this.geoManager.formatAddress(hereAddress);
        item.VRTIA_AddressLabelHere = this.geoManager.limpiarDireccion(item.VRTIA_AddressLabelHere);


        // Limpieza de direcciones
        item.VRTIA_AddressLabelGoogle = this.geoManager.eliminarCommas(item.VRTIA_AddressLabelGoogle);
        item.VRTIA_AddressLabelHere = this.geoManager.eliminarCommas(item.VRTIA_AddressLabelHere);

        // Evaluación de candidatas
        const candidatas = [
          item.VRTIA_AddressLabelHere,
          item.VRTIA_AddressLabelGoogle
        ];
        console.log("VRTIA 15 - Candidatas a dirección:", candidatas);

        //nuevo incio dos

        const mejorCoincidencia = this.geoManager.direccionMasProbable(item.Address, candidatas);
        console.log("VRTIA 16-1 - Mejor coincidencia encontrada:", mejorCoincidencia);
        item.VRTIA_BestMatchAddressLabel = this.geoManager.limpiarDireccion(mejorCoincidencia);
        item.VRTIA_BestMatchAddressLabel = this.geoManager.eliminarCommas(item.VRTIA_BestMatchAddressLabel)
        console.log("VRTIA 17 - Mejor dirección asignada:", item.VRTIA_BestMatchAddressLabel);

        if (!allComponentsConfirmed) {
          googleData = await this.resumenService.validateAddress(`${item.VRTIA_BestMatchAddressLabel}`, "", "CO").toPromise();
          console.log("VRTIA 18 - Revalidación Google:", googleData);

          allComponentsConfirmed = this.areAllAddressComponentsConfirmed(googleData);
          console.log("VRTIA 19 - Componentes confirmados (revalidación):", allComponentsConfirmed);


          validateDistance = allComponentsConfirmed ? 150 : 50;
          item.VRTIA_AllComponentsConfirmed = allComponentsConfirmed;
          item.VRTIA_ValidateDistance = validateDistance;
          console.log("VRTIA 19.1 - VRTIA_BestMatchAddressLabel:", item.VRTIA_BestMatchAddressLabel);
          item.VRTIA_BestMatchAddressLabel = this.geoManager.limpiarDireccion(item.VRTIA_BestMatchAddressLabel);

        }

        hereData = await this.resumenService.getCoordinates(item.VRTIA_BestMatchAddressLabel).toPromise();
        item.VRTIA_ScoringHere = hereData.items[0].scoring.queryScore;
        item.hereData = hereData;
        console.log("VRTIA 20 - Datos HERE revalidados:", hereData);

        herePosition = hereData.items[0].position;
        googlePosition = googleData.result.geocode.location;
        console.log("VRTIA 21 - Item completo actualizado:", item);


        console.log("VRTIA 31 - Negocio más cercano final:", findClosestBusinessByName);

        var isPlace = false
        if (findClosestBusinessByName.matchScore > 0) {

          if(findClosestBusinessByName.nameMatches > 2) {
            isPlace = true
          }

          if (findClosestBusinessByName.place.place_id != "ChIJn3b3BF8pRI4RHKAg-WdeHUI"){
            const details = await this.resumenService.getPlaceDetails(findClosestBusinessByName.place.place_id).toPromise();
            findClosestBusinessByName.place.details = details
            findClosestBusinessByName = findClosestBusinessByName.place;
          }else{
            findClosestBusinessByName = null
          }
       
        }
        const isDistanceGreater = this.geoManager.isDistanceGreaterThan150m(
          herePosition.lat, herePosition.lng,
          googlePosition.latitude, googlePosition.longitude
        );
        console.log("VRTIA 32 - Distancia mayor a 150m:", isDistanceGreater);

        const direccionValidada = item.VRTIA_BestMatchAddressLabel;
        console.log("VRTIA 33 - Dirección final validada:", direccionValidada);

        if (isDistanceGreater) validateDistance = 150;
        console.log("VRTIA 50 salio primero");
        // ==================== RESPUESTA FINAL ====================
        return {
          tareasHistoricas,
          direccionValidada,
          coordenadas: {
            lat: googlePosition.latitude,
            lng: googlePosition.longitude
          },
          googleData,
          hereData,
          isPlace,
          findClosestBusinessByName,
          allComponentsConfirmed,
          isDistanceGreater,
          validateDistance,
          recomendaciones: {
            usarDireccionGoogle: isDistanceGreater || allComponentsConfirmed,
            distanciaValidacion: validateDistance
          }
        };

      } else {
        console.log("VRTIA 00000000");
        /// if de no encontro de la otra forma 

        item.VRTIA_AddressInit = item.VRTIA_WEB_direccion
        let googleData = await this.resumenService.validateAddress(`${item.VRTIA_AddressInit}`, "", "CO").toPromise();
        console.log("VRTIA 5 - Datos de Google:", googleData);

        let allComponentsConfirmed = this.areAllAddressComponentsConfirmed(googleData);
        let validateDistance = allComponentsConfirmed ? 150 : 50;
        let formattedAddress = allComponentsConfirmed
          ? googleData.result.address.formattedAddress
          : direccionLimpia;
        console.log("VRTIA 6 - Componentes confirmados:", allComponentsConfirmed);
        console.log("VRTIA 6.1 - formattedAddress:", allComponentsConfirmed);

        // Asignación de valores a item
        item.VRTIA_AllComponentsConfirmed = allComponentsConfirmed;
        item.VRTIA_FormattedAddress = formattedAddress;
        item.VRTIA_ValidateDistance = validateDistance;

        let googlePosition = googleData.result.geocode.location;

        item.VRTIA_Google_Latitud = googlePosition.latitude;
        item.VRTIA_Google_Longitud = googlePosition.longitude;

        // ==================== PASO 5: CÁLCULO DE DISTANCIAS ====================
        const distanceBetweenReportAndGoogle = this.geoManager.calcularDistanciaEnMetros(
          googlePosition.latitude,
          googlePosition.longitude,
          direccionFinal.latitud,
          direccionFinal.longitud
        );
        item.VRTIA_DistanceBetweenReportAndGoogle = distanceBetweenReportAndGoogle;
        console.log("VRTIA 7 - Distancia reporte-Google:", distanceBetweenReportAndGoogle);

        let distanceBetweenSentPointAndGoogle: number | null = null;
        const lat1 = googlePosition.latitude;
        const lon1 = googlePosition.longitude;
        const lat2 = parseFloat(item.Latitud);
        const lon2 = parseFloat(item.Longitud);

        if (typeof lat1 === 'number' && typeof lon1 === 'number' && !isNaN(lat2) && !isNaN(lon2)) {
          distanceBetweenSentPointAndGoogle = this.geoManager.calcularDistanciaEnMetros(lat1, lon1, lat2, lon2);
        }
        item.VRTIA_DistanceBetweenSentPointAndGoogle = distanceBetweenSentPointAndGoogle;
        console.log("VRTIA 8 - Distancia punto enviado-Google:", distanceBetweenSentPointAndGoogle);

        var getFormattedAddress = this.geoManager.getFormattedAddress(googleData, true).replace(/[#,]/g, ' ');
        console.log("VRTIA 8.1 - reporte-getFormattedAddress:", this.geoManager.limpiarDireccion(getFormattedAddress).replace(/[#,]/g, ' '));


        item.VRTIA_AddressLabelGoogle = this.geoManager.limpiarDireccion(getFormattedAddress).replace(/[#,]/g, ' ')
        // ==================== PASO 6: VALIDACIÓN CON HERE ====================
        let hereData = await this.resumenService.getCoordinates(item.VRTIA_AddressLabelGoogle).toPromise();
        console.log("VRTIA 8.2 - reporte-HERE:", hereData);
        let herePosition = hereData.items[0].position;
        let hereAddress = hereData.items[0].address;
        item.hereData = hereData;
        //nuevo inicio

        const distanceBetweenReportAndHere = this.geoManager.calcularDistanciaEnMetros(
          herePosition.lat,
          herePosition.lng,
          direccionFinal.latitud,
          direccionFinal.longitud
        );
        item.VRTIA_DistanceBetweenReportAndHere = distanceBetweenReportAndHere;
        console.log("VRTIA 9 - Distancia reporte-HERE:", distanceBetweenReportAndHere);

        let distanceBetweenSentPointAndHere: number | null = null;
        const lat1h = herePosition.lat;
        const lon1h = herePosition.lng;
        const lat2h = googlePosition.latitude;
        const lon2h = googlePosition.longitude;

        if (typeof lat1 === 'number' && typeof lon1 === 'number' && !isNaN(lat2) && !isNaN(lon2)) {
          distanceBetweenSentPointAndHere = this.geoManager.calcularDistanciaEnMetros(lat1h, lon1h, lat2h, lon2h);
        }
        console.log("VRTIA 10 - Distancia punto enviado-HERE:", distanceBetweenSentPointAndHere);
        item.VRTIA_DistanceBetweenSentPointAndHere = distanceBetweenSentPointAndHere;

        // Procesamiento de direcciones HERE
        item.VRTIA_AddressLabelHere = this.geoManager.formatAddress(hereAddress);
        item.VRTIA_AddressLabelHere = this.geoManager.limpiarDireccion(item.VRTIA_AddressLabelHere);
        item.VRTIA_AddressLabelGoogle = this.geoManager.eliminarCommas(item.VRTIA_AddressLabelGoogle);
        item.VRTIA_AddressLabelHere = this.geoManager.eliminarCommas(item.VRTIA_AddressLabelHere);


        const searchPlacesRaw = await this.resumenService.searchPlacesRaw(
          googlePosition.latitude, googlePosition.longitude, 50, ""
        ).toPromise();
        console.log("VRTIA 22 - Lugares cercanos encontrados:", searchPlacesRaw);

        var findClosestBusinessByName = this.geoManager.findClosestBusinessByName(item.Client, item.Address, searchPlacesRaw.results);

        /*
        if (findClosestBusinessByName.matchScore > 0) {
          console.log("VRTIA 22-1 - Negocio encontrado:",
            findClosestBusinessByName.place.name,
            "- Score:", findClosestBusinessByName.matchScore);
        } else {
          console.log("VRTIA 23 - Buscando alternativas (centros comerciales)...");

          const shopping_mall = await this.resumenService.searchPlacesRaw(
            googlePosition.latitude, googlePosition.longitude, 50, "shopping_mall"
          ).toPromise();

          if (!shopping_mall.results.length) {
            console.log("VRTIA 24 - Buscando atracciones turísticas...");
            const tourist_attraction = await this.resumenService.searchPlacesRaw(
              googlePosition.latitude, googlePosition.longitude, 50, "tourist_attraction"
            ).toPromise();
            console.log("VRTIA 25 - Atracciones encontradas:", tourist_attraction.results);

            if (!tourist_attraction.results.length) {
              const searchPlacesCentro = await this.resumenService.searchPlacesDetails(item.Client + " Medellin").toPromise();
              console.log("VRTIA 54 - Local por nombre encontrado:", searchPlacesCentro);
              findClosestBusinessByName = this.geoManager.findClosestBusinessByNameVici(item.Client, item.Address, searchPlacesCentro.results);
            } else {
              var negociolabel = tourist_attraction.results[0].name;
              if (negociolabel == 'Aquarium Medellin') {
                negociolabel = 'Parque explora';
              }
              console.log("VRTIA 26 - Búsqueda combinada:", item.Client + " " + this.geoManager.construirDireccion(item.hereData.items[0].address) + " " + negociolabel);

              const searchPlacesCentro = await this.resumenService.searchPlacesDetails(
                item.Client + " " + this.geoManager.construirDireccion(item.hereData.items[0].address) + " " + tourist_attraction.results[0].name + " "
              ).toPromise();
              console.log("VRTIA 27 - Locales encontrados en atracción:", searchPlacesCentro);
              findClosestBusinessByName = this.geoManager.findClosestBusinessByNameVici(item.Client, item.Address, searchPlacesCentro.results);
            }
          } else {
            console.log("VRTIA 28 - Centros comerciales encontrados:", shopping_mall.results);
            const searchPlacesCentro = await this.resumenService.searchPlacesDetails(
              item.Client + " " + this.geoManager.construirDireccion(item.hereData.items[0].address) + " " + shopping_mall.results[0].name + " "
            ).toPromise();
            findClosestBusinessByName = this.geoManager.findClosestBusinessByNameVici(item.Client, item.Address, searchPlacesCentro.results);
            console.log("VRTIA 30 - Negocios encontrados en centro comercial:", findClosestBusinessByName);
          }
        }

        console.log("VRTIA 31 - Negocio más cercano final:", findClosestBusinessByName);

        if (findClosestBusinessByName.matchScore > 0) {
          const isDistancefindClosestBusinessByName = this.geoManager.isDistanceGreater500(
            findClosestBusinessByName.place.geometry.location.lat, findClosestBusinessByName.place.geometry.location.lng,
            googlePosition.latitude, googlePosition.longitude
          );

          console.log("VRTIA 42 - isDistancefindClosestBusinessByName:", isDistancefindClosestBusinessByName);
          const isViable = this.geoManager.tieneNumeroDeDireccion(this.geoManager.limpiarDireccion(findClosestBusinessByName.place.formatted_address))
          console.log("VRTIA 42 - isDistancefindClosestBusinessByName isViable findClosestBusinessByName:", this.geoManager.limpiarDireccion(findClosestBusinessByName.place.formatted_address));
          console.log("VRTIA 42 - isDistancefindClosestBusinessByName isViable:", isViable);
          if (isDistancefindClosestBusinessByName && !isViable) {
            findClosestBusinessByName.matchScore = 0
            findClosestBusinessByName.place = null
          }
        }

              */

          var  isPlace = false
        if (findClosestBusinessByName.matchScore > 0) {

          const details = await this.resumenService.getPlaceDetails(findClosestBusinessByName.place.place_id).toPromise();

          console.log("VRTIA 31.1 - Negocio más cercano final con detalle:", findClosestBusinessByName);
          if(findClosestBusinessByName.nameMatches > 2) {
            isPlace = true
          }

          if (findClosestBusinessByName.matchScore === 101010) {




            const isViable = this.geoManager.validateAddressStructure(this.geoManager.limpiarDireccion(details.formatted_address))


            console.log("VRTIA Entro a recarcular isViable", isViable);
            var direccionComplementada = this.geoManager.limpiarDireccion(details.formatted_address)
            console.log("VRTIA Entro a recarcular isViable direccionComplementada ", direccionComplementada);

            if (!isViable.isValid) {
              console.log("VRTIA ingreo");
              direccionComplementada = this.geoManager.limpiarDireccion(item.Address) + " " + this.geoManager.limpiarDireccion(this.geoManager.formatAddressGoogle(details.address_components))
              console.log("VRTIA Entro a recarcular isViable direccionComplementada ingreso", direccionComplementada);
            } else {
              console.log("VRTIA no ingreo");
            }

            console.log("VRTIA Entro a recarcular", direccionComplementada);
            googleData = await this.resumenService.validateAddress(direccionComplementada, "", "CO").toPromise();
            console.log("VRTIA 5 - Datos de Google:", googleData);

            let allComponentsConfirmed = this.areAllAddressComponentsConfirmed(googleData);
            let validateDistance = allComponentsConfirmed ? 150 : 50;
            let formattedAddress = allComponentsConfirmed
              ? googleData.result.address.formattedAddress
              : direccionLimpia;
            console.log("VRTIA 6 - Componentes confirmados:", allComponentsConfirmed);
            console.log("VRTIA 6.1 - formattedAddress:", allComponentsConfirmed);

            // Asignación de valores a item
            item.VRTIA_AllComponentsConfirmed = allComponentsConfirmed;
            item.VRTIA_FormattedAddress = formattedAddress;
            item.VRTIA_ValidateDistance = validateDistance;

            let googlePosition = googleData.result.geocode.location;
            item.VRTIA_Google_Latitud = googlePosition.latitude;
            item.VRTIA_Google_Longitud = googlePosition.longitude;

            // ==================== PASO 5: CÁLCULO DE DISTANCIAS ====================
            const distanceBetweenReportAndGoogle = this.geoManager.calcularDistanciaEnMetros(
              googlePosition.latitude,
              googlePosition.longitude,
              direccionFinal.latitud,
              direccionFinal.longitud
            );
            item.VRTIA_DistanceBetweenReportAndGoogle = distanceBetweenReportAndGoogle;
            console.log("VRTIA 7 - Distancia reporte-Google:", distanceBetweenReportAndGoogle);

            let distanceBetweenSentPointAndGoogle: number | null = null;
            const lat1 = googlePosition.latitude;
            const lon1 = googlePosition.longitude;
            const lat2 = parseFloat(item.Latitud);
            const lon2 = parseFloat(item.Longitud);

            if (typeof lat1 === 'number' && typeof lon1 === 'number' && !isNaN(lat2) && !isNaN(lon2)) {
              distanceBetweenSentPointAndGoogle = this.geoManager.calcularDistanciaEnMetros(lat1, lon1, lat2, lon2);
            }
            item.VRTIA_DistanceBetweenSentPointAndGoogle = distanceBetweenSentPointAndGoogle;
            console.log("VRTIA 8 - Distancia punto enviado-Google:", distanceBetweenSentPointAndGoogle);

            var getFormattedAddress = this.geoManager.getFormattedAddress(googleData, true).replace(/[#,]/g, ' ');
            console.log("VRTIA 8.1 - reporte-getFormattedAddress:", this.geoManager.limpiarDireccion(getFormattedAddress).replace(/[#,]/g, ' '));


            item.VRTIA_AddressLabelGoogle = this.geoManager.limpiarDireccion(getFormattedAddress).replace(/[#,]/g, ' ')
            // ==================== PASO 6: VALIDACIÓN CON HERE ====================

            if (!isViable.isValid) {
              direccionComplementada = this.geoManager.limpiarDireccion(item.Address) + " " + this.geoManager.limpiarDireccion(this.geoManager.formatAddressGoogle(details.address_components))
            }
            hereData = await this.resumenService.getCoordinates(direccionComplementada).toPromise();
            console.log("VRTIA 8.2 - reporte-HERE:", hereData);
            let herePosition = hereData.items[0].position;
            let hereAddress = hereData.items[0].address;

            const distanceBetweenReportAndHere = this.geoManager.calcularDistanciaEnMetros(
              herePosition.lat,
              herePosition.lng,
              direccionFinal.latitud,
              direccionFinal.longitud
            );
            item.VRTIA_DistanceBetweenReportAndHere = distanceBetweenReportAndHere;
            console.log("VRTIA 9 - Distancia reporte-HERE:", distanceBetweenReportAndHere);

            let distanceBetweenSentPointAndHere: number | null = null;
            const lat1h = herePosition.lat;
            const lon1h = herePosition.lng;
            const lat2h = googlePosition.latitude;
            const lon2h = googlePosition.longitude;

            if (typeof lat1 === 'number' && typeof lon1 === 'number' && !isNaN(lat2) && !isNaN(lon2)) {
              distanceBetweenSentPointAndHere = this.geoManager.calcularDistanciaEnMetros(lat1h, lon1h, lat2h, lon2h);
            }
            console.log("VRTIA 10 - Distancia punto enviado-HERE:", distanceBetweenSentPointAndHere);
            item.VRTIA_DistanceBetweenSentPointAndHere = distanceBetweenSentPointAndHere;

            // Procesamiento de direcciones HERE
            item.VRTIA_AddressLabelHere = this.geoManager.formatAddress(hereAddress);
            item.VRTIA_AddressLabelHere = this.geoManager.limpiarDireccion(item.VRTIA_AddressLabelHere);

            // ==================== PASO 7: GEOCODING Y MEJOR COINCIDENCIA ====================

            item.VRTIA_AddressLabelGoogle = this.geoManager.eliminarCommas(item.VRTIA_AddressLabelGoogle);
            item.VRTIA_AddressLabelHere = this.geoManager.eliminarCommas(item.VRTIA_AddressLabelHere);

            item.hereData = hereData;

          }


          findClosestBusinessByName.place.details = details
          findClosestBusinessByName = findClosestBusinessByName.place;
        } else {
          //findClosestBusinessByName.place.details = []
        }

  

        // ==================== PASO 10: VALIDACIÓN FINAL ====================
        const isDistanceGreater = this.geoManager.isDistanceGreaterThan150m(
          herePosition.lat, herePosition.lng,
          googlePosition.latitude, googlePosition.longitude
        );
        console.log("VRTIA 32 - Distancia mayor a 150m:", isDistanceGreater);

        const direccionValidada = item.VRTIA_BestMatchAddressLabel;
        console.log("VRTIA 33 - Dirección final validada:", direccionValidada);

        if (isDistanceGreater) validateDistance = 150;
        console.log("VRTIA 51 salio segundo");
        // ==================== RESPUESTA FINAL ====================
        return {
          tareasHistoricas,
          direccionValidada,
          coordenadas: {
            lat: googlePosition.latitude,
            lng: googlePosition.longitude
          },
          googleData,
          hereData,
          isPlace,
          findClosestBusinessByName,
          allComponentsConfirmed,
          isDistanceGreater,
          validateDistance,
          recomendaciones: {
            usarDireccionGoogle: isDistanceGreater || allComponentsConfirmed,
            distanciaValidacion: validateDistance
          }
        };
      }





    } catch (error) {
      console.error('❌ Error en procesarItemHistorial:', error);
      throw error;
    }
  }






  async procesarISItemHistorial(item: any, validate: any): Promise<{
    tareasHistoricas: any[],
    direccionValidada: string,
    coordenadas: { lat: number, lng: number },
    googleData: any,
    hereData: any,
    allComponentsConfirmed: boolean,
    isDistanceGreater: boolean,
    validateDistance: number,
    recomendaciones: {
      usarDireccionGoogle: boolean,
      distanciaValidacion: number
    }
  }> {
    try {
      // 1. Obtener fechas para la consulta
      const { fechaActual, fechaDosMesesAtras } = this.geoManager.obtenerFechas();

      // 2. Buscar tareas históricas (sin modificar el item)
      const negocio = localStorage.getItem("negocio");
      const agencia = localStorage.getItem("agencia");

      const tareasHistoricas = await this.obtenerTareasHistoricas(
        negocio,
        agencia,
        item.Address,
        fechaDosMesesAtras,
        fechaActual
      );

      // 3. Validar dirección con Google
      const direccionLimpia = item.VRTIA_AddressNormalized
      const googleData = validate.direccionEncontrada.geoGoogle

      const allComponentsConfirmed = this.areAllAddressComponentsConfirmed(googleData);

      // 4. Determinar parámetros de validación
      let validateDistance = allComponentsConfirmed ? 150 : 50;
      const formattedAddress = allComponentsConfirmed
        ? googleData.result.address.formattedAddress
        : direccionLimpia;

      // 5. Obtener y comparar con HERE
      const hereData = validate.direccionEncontrada.geoHere
      const herePosition = hereData.items[0].position;
      const googlePosition = googleData.result.geocode.location;

      const isDistanceGreater = this.geoManager.isDistanceGreaterThan150m(
        herePosition.lat,
        herePosition.lng,
        googlePosition.latitude,
        googlePosition.longitude
      );

      console.log("isDistanceGreater", isDistanceGreater)
      // 6. Determinar dirección final a usar
      let direccionValidada = formattedAddress;
      if (isDistanceGreater) {
        direccionValidada = this.geoManager.getFormattedAddress(googleData, true);
        validateDistance = 150;
      }

      // 7. Devolver todos los datos calculados
      return {
        tareasHistoricas,
        direccionValidada,
        coordenadas: {
          lat: googlePosition.latitude,
          lng: googlePosition.longitude
        },
        googleData,
        hereData,
        allComponentsConfirmed,
        isDistanceGreater,
        validateDistance,
        recomendaciones: {
          usarDireccionGoogle: isDistanceGreater || allComponentsConfirmed,
          distanciaValidacion: validateDistance
        }
      };

    } catch (error) {
      console.error('Error en procesarItemHistorial:', error);
      throw error;
    }
  }
  // Método auxiliar separado
  private async obtenerTareasHistoricas(negocio: string, agencia: string, direccion: string, desde: string, hasta: string) {
    let response = await this.resumenService.buscarTareasPorDireccion(
      negocio, agencia, direccion, desde, hasta
    ).toPromise();

    if (!response.tareas.length) {
      response = await this.resumenService.buscarTareasPorDireccion(
        negocio, agencia, `${direccion}/${direccion}`, desde, hasta
      ).toPromise();
    }

    if (!response.tareas.length) {

      var direccionInit = this.geoManager.formatAddressInit(direccion)
      console.log("direccion rara", direccionInit)
      response = await this.resumenService.buscarTareasPorDireccion(
        negocio, agencia, `${direccionInit}/${direccionInit}`, desde, hasta
      ).toPromise();

      console.log("direccion raras vdd", `${direccionInit}/${direccionInit}`)
    }

    return response.tareas || [];
  }

  async procesarHistorial() {


  }


  async procesarItem(item) {
    try {

      item.Latitud = parseSafe(item.Latitud);  // Conversión segura
      item.Longitud = parseSafe(item.Longitud); // Conversión segura
      item.VRTIA_AddressInit = this.geoManager.tratamientoGeneral(item) + " " + " Antioquia  Colombia"
      item.VRTIA_AddressNormalized = this.geoManager.limpiarDireccion(item.VRTIA_AddressInit)
      item.VRTIA_Domain = this.geoManager.extraerDominioEmpresarial(item.email)

      item.VRTIA_Inversa = this.geoManager.transformarDireccion(item.Address)
      console.log('addressNormalized:', item);
      const validateGeoIA = await this.resumenService.validateGeo(item.Address).toPromise();
      console.log('validateGeoIA:', validateGeoIA);

      if (item && item.Document) {
        try {
          const getInfoEmpresa = await this.resumenService.getInfoEmpresa(item.Document).toPromise();
          console.log('por lelga a la consulta :');
          if (getInfoEmpresa) {
            console.log('por bien :');
            item.VRTIA_legal_actividadesEconomicas = getInfoEmpresa.actividadesEconomicas || '';
            item.VRTIA_legal_direccionExacta = getInfoEmpresa.direccionExacta || '';
            item.VRTIA_legal_nombre = getInfoEmpresa.nombre || '';
            item.VRTIA_legal_ciudad = getInfoEmpresa.ciudad || '';
           
            console.log('por lelga a la consulta     item.VRTIA_Inversa:',    item.VRTIA_Inversa);
            const consultarNegocio = await this.resumenService.consultarNegocio(getInfoEmpresa.nombre,  item.Address  ,"Antioquia", item.Client, item.VRTIA_Inversa).toPromise();
            console.log('consultarNegocio:', consultarNegocio);
            if (consultarNegocio) {
              item.VRTIA_WEB_direccion = consultarNegocio.direccion;
              item.VRTIA_WEB_latitud = consultarNegocio.latitud;
              item.VRTIA_WEB_longitud = consultarNegocio.longitud;
              item.VRTIA_WEB_marcaComercial = consultarNegocio.marcaComercial;
              item.VRTIA_WEB_nombreComercial = consultarNegocio.marcaComercial;
              item.VRTIA_WEB_nombreLegal = consultarNegocio.nombreLegal;
              item.VRTIA_WEB_nombrePuntoVenta = consultarNegocio.nombrePuntoVenta;
              item.VRTIA_WEB_respuestaTexto = consultarNegocio.respuestaTexto;
              item.VRTIA_WEB_urlMaps = consultarNegocio.urlMaps;
            
              // presenciaEnLinea puede estar anidado
              if (consultarNegocio.presenciaEnLinea) {
                item.VRTIA_WEB_instagram = consultarNegocio.presenciaEnLinea.redesSociales
                  ? consultarNegocio.presenciaEnLinea.redesSociales[0]
                  : null;
                item.VRTIA_WEB_sitioWeb = consultarNegocio.presenciaEnLinea.sitioWeb;
                item.VRTIA_WEB_youtube = consultarNegocio.presenciaEnLinea.youtube;
              }

              if (consultarNegocio.placesCoincidentesFinal.length>0 && consultarNegocio.placesCoincidentesFinal[0].cid != "4764067781482160156") {
                const lugar = consultarNegocio.placesCoincidentesFinal[0];
                item.VRTIA_WEB_tituloCoincidente = lugar.title || null;
                item.VRTIA_WEB_marcaComercial  = lugar.title || null;
                item.VRTIA_WEB_direccionCoincidente = lugar.address || null;
                item.VRTIA_WEB_direccion =   item.VRTIA_WEB_direccionCoincidente
                item.VRTIA_WEB_ratingCoincidente = lugar.rating || null;
                item.VRTIA_WEB_ratingCountCoincidente = lugar.ratingCount || null;
                item.VRTIA_WEB_cidCoincidente = lugar.cid || null;
                item.VRTIA_WEB_latitude = lugar.latitude || null;
                item.VRTIA_WEB_longitude = lugar.longitude || null;
              }
              
            }            
            
          } else {
            console.log('por mal :');
            item.VRTIA_legal_actividadesEconomicas = '';
            item.VRTIA_legal_direccionExacta = '';
            item.VRTIA_legal_nombre = '';
            item.VRTIA_legal_ciudad = '';

            const consultarNegocio = await this.resumenService.consultarNegocio(item.Client,  item.Address  ,"Antioquia", item.Client, item.VRTIA_Inversa).toPromise();
            console.log('consultarNegocio:', consultarNegocio);
            if (consultarNegocio) {
              item.VRTIA_WEB_direccion = consultarNegocio.direccion;
              item.VRTIA_WEB_latitud = consultarNegocio.latitud;
              item.VRTIA_WEB_longitud = consultarNegocio.longitud;
              item.VRTIA_WEB_marcaComercial = consultarNegocio.marcaComercial;
              item.VRTIA_WEB_nombreComercial = consultarNegocio.marcaComercial;
              item.VRTIA_WEB_nombreLegal = consultarNegocio.nombreLegal;
              item.VRTIA_WEB_nombrePuntoVenta = consultarNegocio.nombrePuntoVenta;
              item.VRTIA_WEB_respuestaTexto = consultarNegocio.respuestaTexto;
              item.VRTIA_WEB_urlMaps = consultarNegocio.urlMaps;
            
              // presenciaEnLinea puede estar anidado
              if (consultarNegocio.presenciaEnLinea) {
                item.VRTIA_WEB_instagram = consultarNegocio.presenciaEnLinea.redesSociales
                  ? consultarNegocio.presenciaEnLinea.redesSociales[0]
                  : null;
                item.VRTIA_WEB_sitioWeb = consultarNegocio.presenciaEnLinea.sitioWeb;
                item.VRTIA_WEB_youtube = consultarNegocio.presenciaEnLinea.youtube;
              }
            }  

            if (consultarNegocio.placesCoincidentesFinal.length>0 && consultarNegocio.placesCoincidentesFinal[0].cid != "4764067781482160156") {
              const lugar = consultarNegocio.placesCoincidentesFinal[0];
              item.VRTIA_WEB_marcaComercial  = lugar.title || null;
              item.VRTIA_WEB_tituloCoincidente = lugar.title || null;
              item.VRTIA_WEB_direccionCoincidente = lugar.address || null;
              item.VRTIA_WEB_direccion =   item.VRTIA_WEB_direccionCoincidente
              item.VRTIA_WEB_ratingCoincidente = lugar.rating || null;
              item.VRTIA_WEB_ratingCountCoincidente = lugar.ratingCount || null;
              item.VRTIA_WEB_cidCoincidente = lugar.cid || null;
              item.VRTIA_WEB_latitude = lugar.latitude || null;
              item.VRTIA_WEB_longitude = lugar.longitude || null;
            }
            
          }
        } catch (error) {
          // En caso de error en la llamada al servicio, asignar valores vacíos
          item.VRTIA_legal_actividadesEconomicas = '';
          item.VRTIA_legal_direccionExacta = '';
          item.VRTIA_legal_nombre = '';
          item.VRTIA_legal_ciudad = '';
          console.error('Error al obtener info de empresa:', error);


         var clientefinal =item.Client

         if (clientefinal=="Jardin chino (corona China)".trim()){
          item.Address= "Cr84 #79-35"
         }

          const consultarNegocio = await this.resumenService.consultarNegocio(clientefinal ,  item.Address  ,"Antioquia", item.Client, item.VRTIA_Inversa).toPromise();
          console.log('consultarNegocio:', consultarNegocio);
          if (consultarNegocio) {
            item.VRTIA_WEB_direccion = consultarNegocio.direccion;
            item.VRTIA_WEB_latitud = consultarNegocio.latitud;
            item.VRTIA_WEB_longitud = consultarNegocio.longitud;
            item.VRTIA_WEB_marcaComercial = consultarNegocio.marcaComercial;
            item.VRTIA_WEB_nombreComercial = consultarNegocio.marcaComercial;
            item.VRTIA_WEB_nombreLegal = consultarNegocio.nombreLegal;
            item.VRTIA_WEB_nombrePuntoVenta = consultarNegocio.nombrePuntoVenta;
            item.VRTIA_WEB_respuestaTexto = consultarNegocio.respuestaTexto;
            item.VRTIA_WEB_urlMaps = consultarNegocio.urlMaps;
          
            // presenciaEnLinea puede estar anidado
            if (consultarNegocio.presenciaEnLinea) {
              item.VRTIA_WEB_instagram = consultarNegocio.presenciaEnLinea.redesSociales
                ? consultarNegocio.presenciaEnLinea.redesSociales[0]
                : null;
              item.VRTIA_WEB_sitioWeb = consultarNegocio.presenciaEnLinea.sitioWeb;
              item.VRTIA_WEB_youtube = consultarNegocio.presenciaEnLinea.youtube;
            }
  
            if (consultarNegocio.placesCoincidentesFinal.length>0 && consultarNegocio.placesCoincidentesFinal[0].cid != "4764067781482160156") {
              const lugar = consultarNegocio.placesCoincidentesFinal[0];
              item.VRTIA_WEB_tituloCoincidente = lugar.title || null;
              item.VRTIA_WEB_marcaComercial  = lugar.title || null;
              item.VRTIA_WEB_direccionCoincidente = lugar.address || null;
              item.VRTIA_WEB_direccion =   item.VRTIA_WEB_direccionCoincidente
              item.VRTIA_WEB_ratingCoincidente = lugar.rating || null;
              item.VRTIA_WEB_ratingCountCoincidente = lugar.ratingCount || null;
              item.VRTIA_WEB_cidCoincidente = lugar.cid || null;
              item.VRTIA_WEB_latitude = lugar.latitude || null;
              item.VRTIA_WEB_longitude = lugar.longitude || null;
            }
            
          } 
        }
      } else {
        // Si no hay documento, también asignar valores vacíos
        item.VRTIA_legal_actividadesEconomicas = '';
        item.VRTIA_legal_direccionExacta = '';
        item.VRTIA_legal_nombre = '';
        item.VRTIA_legal_ciudad = '';

        const consultarNegocio = await this.resumenService.consultarNegocio(item.Client,  item.Address  ,"Antioquia", item.Client, item.VRTIA_Inversa).toPromise();
        console.log('consultarNegocio:', consultarNegocio);
        if (consultarNegocio) {
          item.VRTIA_WEB_direccion = consultarNegocio.direccion;
          item.VRTIA_WEB_latitud = consultarNegocio.latitud;
          item.VRTIA_WEB_longitud = consultarNegocio.longitud;
          item.VRTIA_WEB_marcaComercial = consultarNegocio.marcaComercial;
          item.VRTIA_WEB_nombreComercial = consultarNegocio.marcaComercial;
          item.VRTIA_WEB_nombreLegal = consultarNegocio.nombreLegal;
          item.VRTIA_WEB_nombrePuntoVenta = consultarNegocio.nombrePuntoVenta;
          item.VRTIA_WEB_respuestaTexto = consultarNegocio.respuestaTexto;
          item.VRTIA_WEB_urlMaps = consultarNegocio.urlMaps;
        
          // presenciaEnLinea puede estar anidado
          if (consultarNegocio.presenciaEnLinea) {
            item.VRTIA_WEB_instagram = consultarNegocio.presenciaEnLinea.redesSociales
              ? consultarNegocio.presenciaEnLinea.redesSociales[0]
              : null;
            item.VRTIA_WEB_sitioWeb = consultarNegocio.presenciaEnLinea.sitioWeb;
            item.VRTIA_WEB_youtube = consultarNegocio.presenciaEnLinea.youtube;
          }

          if (consultarNegocio.placesCoincidentesFinal.length>0 && consultarNegocio.placesCoincidentesFinal[0].cid != "4764067781482160156" ) {
            const lugar = consultarNegocio.placesCoincidentesFinal[0];
            item.VRTIA_WEB_tituloCoincidente = lugar.title || null;
            item.VRTIA_WEB_marcaComercial  = lugar.title || null;
            item.VRTIA_WEB_direccionCoincidente = lugar.address || null;
            item.VRTIA_WEB_direccion =   item.VRTIA_WEB_direccionCoincidente
            item.VRTIA_WEB_ratingCoincidente = lugar.rating || null;
            item.VRTIA_WEB_ratingCountCoincidente = lugar.ratingCount || null;
            item.VRTIA_WEB_latitude = lugar.latitude || null;
            item.VRTIA_WEB_longitude = lugar.longitude || null;
          }
          
        }  
      }
      


      if (!validateGeoIA.existe) {
        item.isHistorial = false
        const resultados = await this.procesarItemHistorial(item);
        console.log('resultados true:', resultados);

        item.VRTIA_Reportes = resultados.tareasHistoricas
        item.VRTIA_GeoGoogle = resultados.googleData
        item.VRTIA_GeoHere = resultados.hereData
        item.VRTIA_IsPlace = resultados.isPlace
        if (
          resultados &&
          resultados.findClosestBusinessByName &&
          resultados.findClosestBusinessByName.geometry &&
          resultados.findClosestBusinessByName.geometry.location
        ) {
          item.VRTIA_Place_Latitud = resultados.findClosestBusinessByName.geometry.location.lat
          item.VRTIA_Place_Longitud = resultados.findClosestBusinessByName.geometry.location.lng
          item.VRTIA_Place_Name= resultados.findClosestBusinessByName.name
          item.VRTIA_Place_Url= resultados.findClosestBusinessByName.details.url
          item.VRTIA_FindClosestBusinessByName = resultados.findClosestBusinessByName
        }


 
        
        item.VRTIA_StreetView = this.geoManager.getStreetViewUrl(item, resultados);

        const listaConsolidada = this.geoManager.crearListaGeolocalizacion(
          resultados.googleData.result.geocode.location,
          resultados.hereData.items[0].position,
          resultados.tareasHistoricas,
          item
        )
     
        item.VRTIA_ListaConGeo = listaConsolidada
        item.VRTIA_ValidateDistance = resultados.validateDistance;
        item.VRTIA_AllComponentsConfirmed = resultados.allComponentsConfirmed
      

        const listaFiltrada = this.geoManager.filtrarListaConGeo(item.VRTIA_ListaConGeo , { lat: item.VRTIA_GeoGoogle.result.geocode.location.latitude, lng: item.VRTIA_GeoGoogle.result.geocode.location.longitude }, item.validateDistance);

        const dentroDelRadio = this.geoManager.estanTodosDentroDelRadio(listaFiltrada, item.validateDistance);
        console.log("listaFiltrada", listaFiltrada)
        console.log("dentroDelRadio", listaFiltrada)
        const item1 = {
          listaConGeo: listaFiltrada, // 3 geolocalizaciones
          dentroDelRadio: dentroDelRadio.dentroDelRadio
        }
        item.VRTIA_Distance = dentroDelRadio.distanciaMaxima
        item.VRTIA_Status = dentroDelRadio.dentroDelRadio
        item.VRTIA_Score = this.geoManager.calcularScorePorItem(item1)

      } else {
        item.isHistorial = true
       
  
          item.VRTIA_Reportes = validateGeoIA.direccionEncontrada.VRTIA_Reportes
          item.VRTIA_GeoGoogle= validateGeoIA.direccionEncontrada.VRTIA_GeoGoogle
          item.VRTIA_GeoHere= validateGeoIA.direccionEncontrada.VRTIA_GeoHere
          item.VRTIA_AddressInit = validateGeoIA.direccionEncontrada.VRTIA_AddressInit
          item.VRTIA_AddressLabelGoogle= validateGeoIA.direccionEncontrada.VRTIA_AddressLabelGoogle
          item.VRTIA_AddressLabelHere= validateGeoIA.direccionEncontrada.VRTIA_AddressLabelHere
          item.VRTIA_AddressNormalized= validateGeoIA.direccionEncontrada.VRTIA_AddressNormalized
          item.VRTIA_AllComponentsConfirmed= validateGeoIA.direccionEncontrada.VRTIA_AllComponentsConfirmed
          item.VRTIA_BestMatchAddressLabel= validateGeoIA.direccionEncontrada.VRTIA_BestMatchAddressLabel
          item.VRTIA_DistanceBetweenReportAndGoogle= validateGeoIA.direccionEncontrada.VRTIA_DistanceBetweenReportAndGoogle
          item.VRTIA_DistanceBetweenReportAndHere= validateGeoIA.direccionEncontrada.VRTIA_DistanceBetweenReportAndHere
          item.VRTIA_DistanceBetweenSentPointAndGoogle= validateGeoIA.direccionEncontrada.VRTIA_DistanceBetweenSentPointAndGoogle
          item.VRTIA_DistanceBetweenSentPointAndHere= validateGeoIA.direccionEncontrada.VRTIA_DistanceBetweenSentPointAndHere
          item.VRTIA_Domain= validateGeoIA.direccionEncontrada.VRTIA_Domain
          item.VRTIA_FindClosestBusinessByName= validateGeoIA.direccionEncontrada.VRTIA_FindClosestBusinessByName
          item.VRTIA_FormattedAddress= validateGeoIA.direccionEncontrada.VRTIA_FormattedAddress
          item.VRTIA_Google_Latitud= validateGeoIA.direccionEncontrada.VRTIA_Google_Latitud
          item.VRTIA_Google_Longitud= validateGeoIA.direccionEncontrada.VRTIA_Google_Longitud
          item.VRTIA_Place_Latitud= validateGeoIA.direccionEncontrada.VRTIA_Place_Latitud
          item.VRTIA_Place_Longitud= validateGeoIA.direccionEncontrada.VRTIA_Place_Longitud
          item.VRTIA_Place_Name= validateGeoIA.direccionEncontrada.VRTIA_Place_Name
          item.VRTIA_Place_Url= validateGeoIA.direccionEncontrada.VRTIA_Place_Url
          item.VRTIA_ScoringHere= validateGeoIA.direccionEncontrada.VRTIA_ScoringHere
          item.VRTIA_StreetView= validateGeoIA.direccionEncontrada.VRTIA_StreetView
          item.VRTIA_ValidateDistance= validateGeoIA.direccionEncontrada.VRTIA_ValidateDistance
          item.VRTIA_Score= validateGeoIA.direccionEncontrada.VRTIA_Score
          item.VRTIA_Status= validateGeoIA.direccionEncontrada.VRTIA_Status
          item.VRTIA_ListaConGeo = validateGeoIA.direccionEncontrada.VRTIA_ListaConGeo

      }





    } catch (error) {
      item.status = false
      item.score = 0.0
      item.reportes = []
      item.isHistorial = false
      item.validateDistance = 50
      item.vrtIADireccion = this.geoManager.limpiarDireccion(item.Address)
      //this.listaConGeo.push(item)
      console.error('❌ Error:', error);
    }



  }

  async procesarTareas() {
    this.iscargado = true
    this.listaConGeo = []
    var contador = 1
    for (const item of this.data) {
      item.contador = contador
      contador = contador + 1
      await this.procesarItem(item)

    }


    console.log("this.data", this.data)


    this.cargarMapaGeo()

    // Acá pasás las tareas de la ruta al método que quieras
    //
  }



  cargarMapaGeo() {
    const mapasContainer = document.getElementById('mapas-container');
    mapasContainer.innerHTML = '';

    if (mapasContainer) {
      const mapWrapper = document.createElement('div');
      mapWrapper.classList.add('mapa-wrapperdos');

      // Click para seleccionar
      mapWrapper.addEventListener('click', () => {
        document.querySelectorAll('.mapa-wrapperdos').forEach(card => card.classList.remove('selected'));
        mapWrapper.classList.add('selected');
      });

      const titulo = document.createElement('h3');
      titulo.textContent = "Tareas";
      titulo.classList.add('mapa-titulo');

      // Contenedor del mapa y la tabla en columna
      const contentContainer = document.createElement('div');
      contentContainer.classList.add('content-container');

      // Contenedor del mapa
      const mapContainer = document.createElement('div');
      mapContainer.id = `map-Tareas`;
      mapContainer.classList.add('mapa-container');

      // Contenedor de la tabla
      const tablaContainer = document.createElement('div');
      tablaContainer.classList.add('tabla-container');

      const table = document.createElement('table');
      table.classList.add('styled-table');

      const thead = document.createElement('thead');
      thead.innerHTML = `
      <tr>
        <th>Punto</th>
        <th>Tarea</th>
        <th>Cliente</th>
        <th>Dirección</th>
        <th>Normalizar</th>
        <th>Distancia</th>
        <th>Puntaje</th>
        <th>Estado</th>
      </tr>
    `;

      const tbody = document.createElement('tbody');

      // Paginación
      let currentPage = 1;
      const rowsPerPage = 5;
      const totalPages = Math.ceil(this.data.length / rowsPerPage);
      const mapa = new google.maps.Map(mapContainer, {
        center: { lat: this.data[0].VRTIA_GeoGoogle.result.geocode.location.latitude, lng: this.data[0].VRTIA_GeoGoogle.result.geocode.location.longitude }, // Coordenadas de Bogotá

        zoom: 14,
      });
      const colorGen = new ColorGenerator();
      const color = colorGen.generarColorFosforescenteOscuro();
      this.data.forEach(async (item, index) => {
        
        if (
          item &&
          item.VRTIA_FindClosestBusinessByName &&
          item.VRTIA_FindClosestBusinessByName.geometry &&
          item.VRTIA_FindClosestBusinessByName.geometry.location
        ) {
          const business = item.VRTIA_FindClosestBusinessByName;
        
          const marker = new google.maps.Marker({
            map: mapa,
            position: business.geometry.location,
            title: business.name,
            label: {
              text: business.name,
              color: "#000",
              fontSize: "14px",
              fontWeight: "bold"
            }
          });
        
          const infoWindow = new google.maps.InfoWindow({
            content: `
              <div style="max-width: 320px; font-family: Arial;">
                <h2 style="margin: 0 0 5px 0;">${business.name}</h2>
                <p style="margin: 0 0 5px 0;">${business.formatted_address}</p>
              </div>
            `
          });

          
          marker.addListener('click', () => {
            mapa.setCenter(
              marker.getPosition() as google.maps.LatLng);
            mapa.setZoom(20); // Nivel de zoom al hacer clic
          
            infoWindow.open(mapa, marker);
          });

        }

        this.geoManager.agregarMarcadores(item, index, mapa, color);

        const listaFiltrada = this.geoManager.filtrarListaConGeo(item.VRTIA_ListaConGeo , { lat: item.VRTIA_GeoGoogle.result.geocode.location.latitude, lng: item.VRTIA_GeoGoogle.result.geocode.location.longitude }, item.validateDistance);

        if (this.isValidadorGeo) {
          this.geoManager.addGeozonaGeo(listaFiltrada, color, mapa);
        } else {
          var listareportes = listaFiltrada.filter(reporte => reporte.tipo !== "point");
          this.geoManager.addGeozonaGeo(listareportes, color, mapa);
        }


        if (!item.isHistorial) {
    
          const response = await this.resumenService.guardarValidateGeo(
            {
              address: item.Address,
              VRTIA_Reportes: item.VRTIA_Reportes,
              VRTIA_GeoGoogle: item.VRTIA_GeoGoogle,
              VRTIA_GeoHere:item.VRTIA_GeoHere,
              VRTIA_AddressInit: item.VRTIA_AddressInit, // valor correspondiente
              VRTIA_AddressLabelGoogle: item.VRTIA_AddressLabelGoogle, // valor correspondiente
              VRTIA_AddressLabelHere: item.VRTIA_AddressLabelHere, // valor correspondiente
              VRTIA_AddressNormalized: item.VRTIA_AddressNormalized, // valor correspondiente
              VRTIA_AllComponentsConfirmed: item.VRTIA_AllComponentsConfirmed, // valor correspondiente
              VRTIA_BestMatchAddressLabel: item.VRTIA_BestMatchAddressLabel, // valor correspondiente
              VRTIA_DistanceBetweenReportAndGoogle: item.VRTIA_DistanceBetweenReportAndGoogle, // valor correspondiente
              VRTIA_DistanceBetweenReportAndHere: item.VRTIA_DistanceBetweenReportAndHere, // valor correspondiente
              VRTIA_DistanceBetweenSentPointAndGoogle: item.VRTIA_DistanceBetweenSentPointAndGoogle, // valor correspondiente
              VRTIA_DistanceBetweenSentPointAndHere: item.VRTIA_DistanceBetweenSentPointAndHere, // valor correspondiente
              VRTIA_Domain: item.VRTIA_Domain, // valor correspondiente
              VRTIA_FindClosestBusinessByName: item.VRTIA_FindClosestBusinessByName, // valor correspondiente
              VRTIA_FormattedAddress: item.VRTIA_FormattedAddress, // valor correspondiente
              VRTIA_Google_Latitud: item.VRTIA_Google_Latitud, // valor correspondiente
              VRTIA_Google_Longitud: item.VRTIA_Google_Longitud, // valor correspondiente
              VRTIA_Place_Latitud: item.VRTIA_Place_Latitud, // valor correspondiente
              VRTIA_Place_Longitud: item.VRTIA_Place_Longitud, // valor correspondiente
              VRTIA_Place_Name: item.VRTIA_Place_Name, // valor correspondiente
              VRTIA_Place_Url: item.VRTIA_Place_Url, // valor correspondiente
              VRTIA_ScoringHere: item.VRTIA_ScoringHere, // valor correspondiente
              VRTIA_StreetView: item.VRTIA_StreetView, // valor correspondiente
              VRTIA_ValidateDistance: item.VRTIA_ValidateDistance, // valor correspondiente
              VRTIA_Score: item.VRTIA_Score,
              VRTIA_Status: item.VRTIA_Status,
              VRTIA_ListaConGeo : item.VRTIA_ListaConGeo 

            }
          ).toPromise();


        }
      });




      ///



      const renderTablePage = (page: number) => {
        tbody.innerHTML = "";
        const start = (page - 1) * rowsPerPage;
        const end = start + rowsPerPage;

        const tareasPaginadas = this.data.slice(start, end);

        const verificationBadge = `
      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none">
        <!-- Pentágono azul -->
        <path fill="#0095f6" d="M12 2l7 5-2.5 8h-9L5 7z"/>
        <!-- Check blanco en el centro -->
        <path stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" d="M9 12l2 2 4-4"/>
      </svg>
    `;

        tareasPaginadas.sort((a, b) => Number(b.distance || 0) - Number(a.distance || 0));

        tareasPaginadas.forEach(tarea => {
          const row = document.createElement('tr');
          row.innerHTML = `
        <td>${tarea.contador}</td>
          <td>${tarea.visitLabel}</td>
          <td>${tarea.Client}</td>
          <td>${tarea.Address}</td>
          <td>${tarea.VRTIA_FormattedAddress}</td>
          <td>${Number(tarea.VRTIA_ValidateDistance || 0).toFixed(1)}</td>
          <td>${tarea.VRTIA_Score}</td>
      <td>
            <img src="assets/${tarea.VRTIA_Status ? 'verification.svg' : 'error.svg'}" 
                 alt="${tarea.VRTIA_Status ? 'Verificado' : 'Error'}" 
                 width="20" height="20">
        </td>
    `;


          // Agregar evento click a la fila
          row.addEventListener('click', () => {

            this.mostrarDialogoDetalles(tarea);
          });


          tbody.appendChild(row);
        });

        // Actualizar contador de página
        pageIndicator.textContent = `Página ${currentPage} de ${totalPages} | ${this.data.length}`;
      };


      table.appendChild(thead);
      table.appendChild(tbody);
      tablaContainer.appendChild(table);

      // Controles de paginación
      const paginationContainer = document.createElement('div');
      paginationContainer.classList.add('pagination-container');

      const prevButton = document.createElement('button');
      prevButton.textContent = "⬅️ Anterior";
      prevButton.disabled = true;
      prevButton.addEventListener("click", () => {
        if (currentPage > 1) {
          currentPage--;
          renderTablePage(currentPage);
          nextButton.disabled = false;
          if (currentPage === 1) prevButton.disabled = true;
        }
      });

      const pageIndicator = document.createElement('span');
      pageIndicator.classList.add('page-indicator');

      const nextButton = document.createElement('button');
      nextButton.textContent = "Siguiente ➡️";
      if (this.data.length <= rowsPerPage) nextButton.disabled = true;
      nextButton.addEventListener("click", () => {
        if (currentPage < totalPages) {
          currentPage++;
          renderTablePage(currentPage);
          prevButton.disabled = false;
          if (currentPage === totalPages) nextButton.disabled = true;
        }
      });

      paginationContainer.appendChild(prevButton);
      paginationContainer.appendChild(pageIndicator);
      paginationContainer.appendChild(nextButton);
      tablaContainer.appendChild(paginationContainer);

      // Renderizar la primera página de la tabla
      renderTablePage(currentPage);

      // Agregar mapa y tabla al contenedor principal
      contentContainer.appendChild(mapContainer);
      contentContainer.appendChild(tablaContainer);

      // Agregar elementos al wrapper
      mapWrapper.appendChild(titulo);
      mapWrapper.appendChild(contentContainer);
      mapasContainer.appendChild(mapWrapper);


      this.iscargado = false
      //this.calcularRutaConWaypoints(datosFiltrados,mapa)

    }

    this.iscargado = false

  }




  async procesarTareasUpdate() {
    this.iscargado = true

    //



    const mapasContainer = document.getElementById('mapas-container');
    mapasContainer.innerHTML = '';
    if (mapasContainer) {
      const mapWrapper = document.createElement('div');
      mapWrapper.classList.add('mapa-wrapperdos');

      // Click para seleccionar
      mapWrapper.addEventListener('click', () => {
        document.querySelectorAll('.mapa-wrapperdos').forEach(card => card.classList.remove('selected'));
        mapWrapper.classList.add('selected');
      });

      const titulo = document.createElement('h3');
      titulo.textContent = "Tareas";
      titulo.classList.add('mapa-titulo');

      // Contenedor del mapa y la tabla en columna
      const contentContainer = document.createElement('div');
      contentContainer.classList.add('content-container');

      // Contenedor del mapa
      const mapContainer = document.createElement('div');
      mapContainer.id = `map-Tareas`;
      mapContainer.classList.add('mapa-container');

      // Contenedor de la tabla
      const tablaContainer = document.createElement('div');
      tablaContainer.classList.add('tabla-container');

      const table = document.createElement('table');
      table.classList.add('styled-table');

      const thead = document.createElement('thead');
      thead.innerHTML = `
      <tr>
        <th>Punto</th>
        <th>Tarea</th>
        <th>Cliente</th>
        <th>Dirección</th>
        <th>Normalizar</th>
        <th>Ciudad</th>
        <th>Barrio</th>
        <th>Prefijo</th>
        <th>Numero</th>
        <th>Distancia</th>
        <th>Puntaje</th>
        <th>Estado</th>
      </tr>
    `;

      const tbody = document.createElement('tbody');

      // Paginación
      let currentPage = 1;
      const rowsPerPage = 5;
      const totalPages = Math.ceil(this.data.length / rowsPerPage);


      // Inicializar el mapa con Google Maps



      const mapa = new google.maps.Map(mapContainer, {
        center: { lat: this.data[0].VRTIA_GeoGoogle.result.geocode.location.latitude, lng: this.data[0].VRTIA_GeoGoogle.result.geocode.location.longitude }, // Coordenadas de Bogotá

        zoom: 14,
      });
      const colorGen = new ColorGenerator();
      const color = colorGen.generarColorFosforescenteOscuro();
      this.data.forEach(async (item, index) => {
        var listaGeoZona: any[] = [];

        if (item.isHistorial) {



          item.VRTIA_ListaConGeo .forEach(reportes => {

            if (reportes.type == "google") {

              if (reportes.lat != 0.0) {

                new google.maps.Marker({
                  position: { lat: reportes.lat, lng: reportes.lng },
                  map: mapa,
                  label: {
                    text: index.toString(), // Muestra el número en el centro
                    color: "#000", // Color del número
                    fontSize: "8px",
                    fontWeight: "normal",
                  },
                  icon: {
                    path: "M 0,-15 L 12,10 L -12,10 Z", // 🔺 Triángulo equilátero
                    fillColor: "#FFFF", // Amarillo dorado para mejor visibilidad
                    fillOpacity: 0.5,
                    strokeColor: "orange",
                    strokeWeight: 2,
                    scale: 1.5, // Ajusta el tamaño según sea necesario
                  }
                });

              }
            }

            if (this.isValidadorGeo) {
              if (reportes.type == "point") {

                var marker = new google.maps.Marker({
                  position: { lat: reportes.lat, lng: reportes.lng },
                  map: mapa,
                  label: {
                    text: index.toString(), // Muestra el número en el centro
                    color: "#000", // Color del número
                    fontSize: "8px",
                    fontWeight: "normal",
                  },
                  icon: {
                    path: google.maps.SymbolPath.CIRCLE,
                    fillColor: color,
                    fillOpacity: 0.8,
                    strokeColor: color,
                    strokeWeight: 1,
                    scale: 10, // Tamaño del círculo
                  }
                });

                const infoWindow = new google.maps.InfoWindow({
                  content: `
                    <div style="
                        font-size: 6px;
                        padding: 1px;
                        max-width: 160px;
                        border-radius: 2px;
                        text-align: center;
                    ">
                        <h4 style="margin: 0; font-size: 14px;">${item.Address}</h4>
                        <p style="margin: 0px 0; font-size: 12px;"><strong>Cliente:</strong> ${item.Client}</p>
        
                    </div>
                `
                });

                // Hacer zoom y centrar el mapa al hacer clic en el marcador
                marker.addListener("click", () => {
                  mapa.setCenter(marker.getPosition() as google.maps.LatLng);
                  mapa.setZoom(14); // Nivel de zoom al hacer clic
                  infoWindow.open(mapa, marker);
                });


              }

            }



            if (reportes.type == "here") {


              new google.maps.Marker({
                position: { lat: reportes.lat, lng: reportes.lng },
                map: mapa,
                label: {
                  text: index.toString(), // Muestra el número en el centro
                  color: "#000", // Color del número
                  fontSize: "8px",
                  fontWeight: "normal",
                },
                icon: {
                  path: "M 0,-15 L 14,-5 L 9,12 L -9,12 L -14,-5 Z", // Pentágono
                  fillColor: "#FFFF",
                  fillOpacity: 0.5,
                  strokeColor: "blue",
                  strokeWeight: 2,
                  scale: 1,
                }
              });



            }

            if (reportes.type == "report") {



              new google.maps.Marker({
                position: { lat: reportes.lat, lng: reportes.lng },
                map: mapa,
                label: {
                  text: index.toString(), // Muestra el número en el centro
                  color: "#000", // Color del número
                  fontSize: "8px",
                  fontWeight: "normal",
                },
                icon: {
                  path: "M -5,-5 L 5,-5 L 5,5 L -5,5 Z",
                  fillColor: "#FFFF",
                  fillOpacity: 0.5,
                  strokeColor: "green", // 🔹 Borde verde si "SI", rojo si no
                  strokeWeight: 2, // 🔹 Puedes ajustar el grosor del borde si es necesario
                  scale: 3, // Tamaño del círculo
                }
              });



            }



          });

          const listaFiltrada = this.geoManager.filtrarListaConGeo(item.VRTIA_ListaConGeo , { lat: item.VRTIA_GeoGoogle.result.geocode.location.latitude, lng: item.VRTIA_GeoGoogle.result.geocode.location.longitude }, item.validateDistance);
          console.log("ingreso por point cero")
          if (this.isValidadorGeo) {
              console.log("ingreso por point uno")

            this.geoManager.addGeozonaGeo(listaFiltrada, color, mapa);
          } else {
            console.log("ingreso por point dos")
            var listareportes = listaFiltrada.filter(reporte => reporte.tipo !== "point");
            this.geoManager.addGeozonaGeo(listareportes, color, mapa);
          }




        } else {

          if (item.reportes.length > 0) {


            item.reportes.forEach(reportes => {

              if (reportes.lonTarea != 0.0) {
                new google.maps.Marker({
                  position: { lat: reportes.latTarea, lng: reportes.lonTarea },
                  map: mapa,
                  label: {
                    text: index.toString(), // Muestra el número en el centro
                    color: "#000", // Color del número
                    fontSize: "8px",
                    fontWeight: "normal",
                  },
                  icon: {
                    path: "M -5,-5 L 5,-5 L 5,5 L -5,5 Z",
                    fillColor: "#FFFF",
                    fillOpacity: 0.5,
                    strokeColor: reportes.sitio_reporte === "SI" ? "green" : "red", // 🔹 Borde verde si "SI", rojo si no
                    strokeWeight: 2, // 🔹 Puedes ajustar el grosor del borde si es necesario
                    scale: 3, // Tamaño del círculo
                  }
                });


                listaGeoZona.push({ lat: reportes.latTarea, lng: reportes.lonTarea, type: "report" })


              }

            });



          }

          new google.maps.Marker({
            position: { lat: item.VRTIA_GeoGoogle.result.geocode.location.latitude, lng: item.VRTIA_GeoGoogle.result.geocode.location.longitude },
            map: mapa,
            label: {
              text: index.toString(), // Muestra el número en el centro
              color: "#000", // Color del número
              fontSize: "8px",
              fontWeight: "normal",
            },
            icon: {
              path: "M 0,-15 L 12,10 L -12,10 Z", // 🔺 Triángulo equilátero
              fillColor: "#FFFF", // Amarillo dorado para mejor visibilidad
              fillOpacity: 0.5,
              strokeColor: "orange",
              strokeWeight: 2,
              scale: 1.5, // Ajusta el tamaño según sea necesario
            }
          });



          listaGeoZona.push({ lat: item.VRTIA_GeoGoogle.result.geocode.location.latitude, lng: item.VRTIA_GeoGoogle.result.geocode.location.longitude, type: "google" })
          if (item.geoHere.items.length > 0) {
            const reportes = item.geoHere.items[0]; // Solo tomar el primer elemento


            new google.maps.Marker({
              position: { lat: reportes.position.lat, lng: reportes.position.lng },
              map: mapa,
              label: {
                text: index.toString(), // Muestra el número en el centro
                color: "#000", // Color del número
                fontSize: "8px",
                fontWeight: "normal",
              },
              icon: {
                path: "M 0,-15 L 14,-5 L 9,12 L -9,12 L -14,-5 Z", // Pentágono
                fillColor: "#FFFF",
                fillOpacity: 0.5,
                strokeColor: "blue",
                strokeWeight: 2,
                scale: 1,
              }
            });



            listaGeoZona.push({ lat: reportes.position.lat, lng: reportes.position.lng, type: "here" });
          }


          if (this.isValidadorGeo) {

            var marker = new google.maps.Marker({
              position: { lat: item.Latitud, lng: item.Longitud },
              map: mapa,
              label: {
                text: index.toString(), // Muestra el número en el centro
                color: "#000", // Color del número
                fontSize: "8px",
                fontWeight: "normal",
              },
              icon: {
                path: google.maps.SymbolPath.CIRCLE,
                fillColor: color,
                fillOpacity: 0.8,
                strokeColor: color,
                strokeWeight: 1,
                scale: 10, // Tamaño del círculo
              }
            });
            const infoWindow = new google.maps.InfoWindow({
              content: `
              <div style="
                  font-size: 6px;
                  padding: 1px;
                  max-width: 160px;
                  border-radius: 2px;
                  text-align: center;
              ">
                  <h4 style="margin: 0; font-size: 14px;">${item.Address}</h4>
                  <p style="margin: 0px 0; font-size: 12px;"><strong>Cliente:</strong> ${item.Client}</p>
  
              </div>
          `
            });
            // Hacer zoom y centrar el mapa al hacer clic en el marcador
            marker.addListener("click", () => {
              mapa.setCenter(marker.getPosition() as google.maps.LatLng);
              mapa.setZoom(14); // Nivel de zoom al hacer clic
              infoWindow.open(mapa, marker);
            });
          }
          console.log("isValidadorGeo antes de validar geo", item)
          if (this.isValidadorGeo) {
            console.log("isValidadorGeo true", item)
            listaGeoZona.push({ lat: item.Latitud, lng: item.Longitud, type: "point" })
          }

          console.log("isValidadorGeo listaGeoZona", listaGeoZona)
          const listaFiltrada = this.geoManager.filtrarListaConGeo(listaGeoZona, { lat: item.VRTIA_GeoGoogle.result.geocode.location.latitude, lng: item.VRTIA_GeoGoogle.result.geocode.location.longitude }, item.validateDistance);
          const dentroDelRadio = this.geoManager.estanTodosDentroDelRadio(listaFiltrada, item.validateDistance);
         // this.validateGeo.status = dentroDelRadio.dentroDelRadio

         item.VRTIA_ListaConGeo  = listaGeoZona

          if (listaGeoZona.length > 2) {
            item.status = dentroDelRadio.dentroDelRadio
            item.distance = dentroDelRadio.distanciaMaxima
            if (dentroDelRadio.dentroDelRadio) {
              item.score = 100.0
              //this.validateGeo.score = 100.0
            } else {
              item.score = 70.0
             // this.validateGeo.score = 70.0
            }

          } else {
            //this.validateGeo.status = false
            item.status = false

            if (listaGeoZona.length == 3) {
              item.score = 70.0
             // this.validateGeo.score = 70.0
            }

            if (listaGeoZona.length == 2) {
              item.score = 50.0
            //  this.validateGeo.score = 50.0
            }
            if (listaGeoZona.length == 1) {
              item.score = 20.0
            //  this.validateGeo.score = 20.0
            }
          }
          //this.validateGeo.geoGoogle = item.geoGoogle;
        //  this.validateGeo.geoHere = item.geoHere;
        //  this.validateGeo.reportes = item.reportes;

          if (item.geoHere && item.geoHere.items[0] && item.geoHere.items[0].address) {
            const { address } = item.geoHere.items[0];
          //  this.validateGeo.postalCode = address.postalCode;
          //  this.validateGeo.street = address.street;
           // this.validateGeo.validateDistance = item.validateDistance


            item.city = address.city;
            item.countryName = address.countryName;
            item.county = address.county;
            item.district = address.district;
            item.houseNumber = address.houseNumber;
            item.label = address.label;
            item.postalCode = address.postalCode;
            item.street = address.street;
          }


         // this.validateGeo.business = localStorage.getItem("negocio");
         // this.validateGeo.agency = localStorage.getItem("agencia");
        //  this.validateGeo.address = this.geoManager.limpiarDireccion(item.AddressInit)
        //  this.validateGeo.longitude = item.geoGoogle.result.geocode.location.longitude
         // this.validateGeo.latitude = item.geoGoogle.result.geocode.location.latitude

          //this.validateGeo.validate = listaGeoZona
          //this.validateGeo.distance = dentroDelRadio.distanciaMaxima

          /*
          const response = await this.resumenService.guardarValidateGeo(
            this.validateGeo
          ).toPromise();
          */

          this.geoManager.addGeozonaGeo(listaGeoZona, color, mapa);

        }



      });

      const renderTablePage = (page: number) => {
        tbody.innerHTML = "";
        const start = (page - 1) * rowsPerPage;
        const end = start + rowsPerPage;
        const tareasPaginadas = this.data.slice(start, end);
        const verificationBadge = `
      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none">
        <!-- Pentágono azul -->
        <path fill="#0095f6" d="M12 2l7 5-2.5 8h-9L5 7z"/>
        <!-- Check blanco en el centro -->
        <path stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" d="M9 12l2 2 4-4"/>
      </svg>
    `;

        tareasPaginadas.sort((a, b) => Number(b.distance || 0) - Number(a.distance || 0));

        tareasPaginadas.forEach(tarea => {
          const row = document.createElement('tr');
          row.innerHTML = `
        <td>${tarea.contador}</td>
          <td>${tarea.visitLabel}</td>
          <td>${tarea.Client}</td>
          <td>${tarea.Address}</td>
          <td>${this.geoManager.limpiarDireccion(tarea.VRTIA_FormattedAddress)}</td>
          <td>${tarea.city}</td>
          <td>${tarea.district}</td>
          <td>${tarea.street}</td>
          <td>${tarea.houseNumber}</td>
          <td>${Number(tarea.distance || 0).toFixed(1)}</td>
          <td>${tarea.score}</td>
      <td>
            <img src="assets/${tarea.status ? 'verification.svg' : 'error.svg'}" 
                 alt="${tarea.status ? 'Verificado' : 'Error'}" 
                 width="20" height="20">
        </td>
    `;


          // Agregar evento click a la fila
          row.addEventListener('click', () => {

            this.mostrarDialogoDetalles(tarea);
          });


          tbody.appendChild(row);
        });

        // Actualizar contador de página
        pageIndicator.textContent = `Página ${currentPage} de ${totalPages} | ${this.data.length}`;
      };


      table.appendChild(thead);
      table.appendChild(tbody);
      tablaContainer.appendChild(table);

      // Controles de paginación
      const paginationContainer = document.createElement('div');
      paginationContainer.classList.add('pagination-container');

      const prevButton = document.createElement('button');
      prevButton.textContent = "⬅️ Anterior";
      prevButton.disabled = true;
      prevButton.addEventListener("click", () => {
        if (currentPage > 1) {
          currentPage--;
          renderTablePage(currentPage);
          nextButton.disabled = false;
          if (currentPage === 1) prevButton.disabled = true;
        }
      });

      const pageIndicator = document.createElement('span');
      pageIndicator.classList.add('page-indicator');

      const nextButton = document.createElement('button');
      nextButton.textContent = "Siguiente ➡️";
      if (this.data.length <= rowsPerPage) nextButton.disabled = true;
      nextButton.addEventListener("click", () => {
        if (currentPage < totalPages) {
          currentPage++;
          renderTablePage(currentPage);
          prevButton.disabled = false;
          if (currentPage === totalPages) nextButton.disabled = true;
        }
      });

      paginationContainer.appendChild(prevButton);
      paginationContainer.appendChild(pageIndicator);
      paginationContainer.appendChild(nextButton);
      tablaContainer.appendChild(paginationContainer);

      // Renderizar la primera página de la tabla
      renderTablePage(currentPage);

      // Agregar mapa y tabla al contenedor principal
      contentContainer.appendChild(mapContainer);
      contentContainer.appendChild(tablaContainer);

      // Agregar elementos al wrapper
      mapWrapper.appendChild(titulo);
      mapWrapper.appendChild(contentContainer);
      mapasContainer.appendChild(mapWrapper);


      this.iscargado = false
      //this.calcularRutaConWaypoints(datosFiltrados,mapa)

    }

    this.iscargado = false
    // Acá pasás las tareas de la ruta al método que quieras
    //
  }




  areAllAddressComponentsConfirmed(response: any): boolean {
    return response.result.address.addressComponents.every(
      (component: any) => component.confirmationLevel === 'CONFIRMED'
    ) || false;
  }


  mostrarDialogoDetalles(tarea): void {


    console.log("mostrarDialogoDetalles", tarea)

    // const tareaEncontrada = this.data.find(task => task.visitlabel === tarea.visitlabel);
    this.geosincronizar = tarea

    console.log("mostrarDialogoDetalles     this.geosincronizar ",     this.geosincronizar )

    const dialogRef = this.dialogagregar.open(DialogGeoDetelle, {
      width: '98vw', // 90% del viewport width
      height: '98vh', // Ajusta según necesidad

      data: tarea,
      disableClose: false,
      panelClass: 'custom-dialog-container'
    });

    dialogRef.componentInstance.accepted.subscribe(() => {

      this.data = this.geoManager.reemplazarItemPorVisitLabel(this.data, this.geosincronizar);
      this.procesarTareasUpdate();

    });

  }



  mapVisitsToRequest(visits: any[]): any {

    const esquemaObj = this.esquemas.find(e => e.id === this.esquemaSeleccionado);
    const init = [esquemaObj.modeloGestion.modelo.longitudInicial, esquemaObj.modeloGestion.modelo.latitudInicial]
    const end = [esquemaObj.modeloGestion.modelo.longitudFinal, esquemaObj.modeloGestion.modelo.latitudFinal]


    const origen = { lat: esquemaObj.modeloGestion.modelo.latitudInicial, lng: esquemaObj.modeloGestion.modelo.longitudInicial, }; // Nueva York
    const distanciaKm = 50;
    const direccion = 90; // 0° Norte, 90° Este, 180° Sur, 270° Oeste


    const nuevoPunto = this.geoManager.calculateDestination(origen.lat, origen.lng, distanciaKm, direccion);
    console.log(`Nueva ubicación: Lat ${nuevoPunto.lat}, Lng ${nuevoPunto.lng}`);

    const locations = visits.map(visit => ({
      name: visit.visitLabel,
      coordinates: [visit.lon, visit.lat]
    }));

    if (this.permitirReabastecimiento) {
      locations.push({ name: "init", coordinates: init })
      locations.push({ name: "end", coordinates: end })
    } else {
      locations.push({ name: "initCiclo", coordinates: init })
      locations.push({ name: "init", coordinates: [nuevoPunto.lng, nuevoPunto.lat] })
      locations.push({ name: "end", coordinates: end })
    }

    const vehicles = this.vehiclesesquemaviewSelecciona
    var services = []
    const shipments = visits.map((visit, index) => ({
      name: String(index),
      from: "init", // Primer punto como origen
      to: visit.visitLabel,
      size: {
        amount: 1,
      },
      requirements: [],
      pickup_duration: visit.pickup_duration,  //13.5 = x
      dropoff_duration: visit.dropoff_duration,
      dropoff_times: []
    }))

    if (!this.permitirReabastecimiento) {
      this.vehiclesesquemaviewSelecciona.forEach(vehicle => {



        shipments.push({
          name: vehicle.name,
          requirements: [
            vehicle.name
          ],
          from: "init", // Primer punto como origen
          to: "initCiclo",
          size: {
            amount: 1,
          },
          pickup_duration: 1,  //13.5 = x
          dropoff_duration: 1,
          dropoff_times: [{
            earliest: "2025-03-31T08:00:00Z",
            latest: "2025-03-31T23:30:00Z",
            type: "soft"
          }
          ]
        })



      });

      /*
     services = this.vehiclesesquemaview.map((visit, index) => ({
        name: String(index),
        location: "initCiclo",
        duration:1400,
        requirements: [
          vehicle.name
        ]
      }))
      */

    }






    //min-schedule-completion-time rellena
    //min-total-travel-duration reparte
    const options = {
      objectives: [this.tipoOptimizacionSeleccionado]
    }
    return { version: 1, locations, vehicles, shipments, options, services };
  }






  ngOnDestroy(): void {
    if (this.intervalo) {
      clearInterval(this.intervalo);
    }
  }

  getDateTimeWithStartTime(startime: number): string {
    // 1. Obtener la fecha actual en UTC (sin la hora)
    const now = new Date();
    const currentDate = new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate()));

    // 2. Convertir el decimal startime a total de segundos
    const totalSeconds = startime * 24 * 60 * 60;

    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = Math.floor(totalSeconds % 60);

    // 3. Asignar la hora calculada a la fecha actual
    currentDate.setUTCHours(hours, minutes, seconds, 0);

    // 4. Convertir a formato ISO 8601 con +00:00
    const isoString = currentDate.toISOString().replace('Z', '+00:00');

    return isoString;
  }
  moverVehiculo(event: CdkDragDrop<any[]>) {
    if (event.previousContainer === event.container) {
      // Mover dentro de la misma lista
      moveItemInArray(
        event.container.data,
        event.previousIndex,
        event.currentIndex
      );
    } else {
      // Transferir entre listas diferentes
      transferArrayItem(
        event.previousContainer.data,
        event.container.data,
        event.previousIndex,
        event.currentIndex
      );

      // Actualizar el estado después del movimiento
      this.actualizarEstadoVehiculos();
    }
  }

  // Métodos adicionales para mover con botones
  moverASeleccionados(vehiculo: any) {
    // Buscar en qué lista está actualmente el vehículo
    if (this.resultadoVRT.vehiculosNuevos.includes(vehiculo)) {
      this.transferirEntreListas(
        this.resultadoVRT.vehiculosNuevos,
        this.resultadoVRT.vehiculosSeleccionados,
        vehiculo
      );
    } else if (this.resultadoVRT.vehiculosNoUtilizados.includes(vehiculo)) {
      this.transferirEntreListas(
        this.resultadoVRT.vehiculosNoUtilizados,
        this.resultadoVRT.vehiculosSeleccionados,
        vehiculo
      );
    }
  }

  moverANoUtilizados(vehiculo: any) {
    this.transferirEntreListas(
      this.resultadoVRT.vehiculosSeleccionados,
      this.resultadoVRT.vehiculosNoUtilizados,
      vehiculo
    );
  }

  private transferirEntreListas(origen: any[], destino: any[], item: any) {
    const index = origen.indexOf(item);
    if (index !== -1) {
      origen.splice(index, 1);
      destino.push(item);
      this.actualizarEstadoVehiculos();
    }
  }

  actualizarEstadoVehiculos() {
    // Aquí puedes agregar lógica para actualizar el estado
    // o hacer llamadas a servicios si es necesario
    console.log('Estado actualizado:', this.resultadoVRT);
  }


  calcularVehiculosNecesariosView() {

    var cargaRequerida = { volume: 5000, weight: 10000, boxes: this.data.length };
    this.resultadoVRT = this.calcularVehiculosNecesarios(this.vehiclesesquemaview, cargaRequerida)
    this.vehiclesesquemaviewSelecciona = this.resultadoVRT.vehiculosSeleccionados;


  }

  panelVrtAbierto = true;

  togglePanelVrt() {
    this.panelVrtAbierto = !this.panelVrtAbierto;
  }
  optimizeRoutesView() {
    this.vehiclesesquemaviewSelecciona = [];
    this.intentoActual = 0
    this.optimizeRoutes()
  }
  optimizeRoutes() {


    if (!this.esquemaSeleccionado) {
      this.toastr.errorToastr('Por favor seleccione un esquema');
      return;
    }

    if (!this.criterioReabastecimiento) {
      this.toastr.errorToastr('Por favor seleccione un criterio de reabastecimiento');
      return;
    }

    if (this.permitirReabastecimiento === undefined || this.permitirReabastecimiento === null) {
      this.toastr.errorToastr('Por favor defina si permite reabastecimiento');
      return;
    }


    if (this.data.length == 0) {
      this.toastr.errorToastr('Cargar un archivo');
      return;
    }



    var cargaRequerida = { volume: 5000, weight: 10000, boxes: this.data.length };
    //this.calcularVehiculosNecesarios(this.vehiclesesquemaview,cargaRequerida)
    const calculoVehiculos = this.calcularVehiculosNecesarios(this.vehiclesesquemaview, cargaRequerida);
    this.vehiclesesquemaviewSelecciona = calculoVehiculos.vehiculosSeleccionados
    /*
     this.vehiclesesquemaviewSelecciona = [
       ...calculoVehiculos.vehiculosSeleccionados,
       ...calculoVehiculos.vehiculosNuevos
     ];
    */

    this.resumenService.getOptimizedTrip(this.mapVisitsToRequest(this.data)).subscribe(
      (response) => {

        this.token = response.id
        this.toastr.successToastr('Ruteo en progreso ' + this.token, 'Notificación');
        if (this.subscription && !this.subscription.closed) {
          return;
        }
        this.subscription = timer(0, 15000).subscribe(() => {
          this.resultado();
        });
        //this.response = response;
        // this.processResponse(response); // Procesar la respuesta
      },
      (error) => {

        this.toastr.errorToastr("Error en el archivo inicial");
      }
    );


  }


  resultado() {


    this.resumenService.getTripStatus(this.token).subscribe(
      (response) => {



        if (this.intentoActual >= 5) {
          console.warn("Se alcanzó el límite máximo de intentos.");
          this.subscription.unsubscribe();
          return;
        }

        if (response.code === "unsolvable") {

          this.intentoActual = this.intentoActual + 1
          this.toastr.warningToastr(response.message)
          var fechaFinHora = ""
          var fechaFinInicial = ""


          this.vehiclesesquemaview = this.vehiclesesquemaview.map(vehiculo => {

            const fechaFin = new Date(vehiculo.latest_end);
            fechaFinInicial = vehiculo.latest_end
            fechaFin.setHours(fechaFin.getHours() + 2);

            fechaFinHora = fechaFin.toISOString()

            return {
              ...vehiculo,
              latest_end: fechaFin.toISOString(),
            };
          });

          this.updatedVehiclesList.push({
            intento: this.intentoActual,
            fechaFinAjustada: fechaFinInicial,
            resultado: response.message,
            exito: false
          });


          this.optimizeRoutes()

          return;
        }

        if (response.status === "processing") {
          this.toastr.infoToastr("En progreso")
          return;
        }


        this.subscription.unsubscribe();

        this.visitsFromResponse = this.getLocationVehiclePairs(response.routes)

        if (!this.visitsFromResponse || this.visitsFromResponse.length === 0) {
          this.toastr.warningToastr("Problema de optimización sin solucion")
          return; // o continuar con el flujo según tu lógica
        }
        const fechaFinAjustada =
          this.vehiclesesquemaview.length > 0 ? this.vehiclesesquemaview[0].latest_end : "";

        this.updatedVehiclesList.push({
          intento: this.intentoActual,
          fechaFinAjustada: fechaFinAjustada,
          resultado: response.message,
          exito: true
        });

        this.updatedVehiclesList.forEach(intento => {
          console.log(`Intento ${intento.intento}:`, {
            fechaFinAjustada: intento.fechaFinAjustada,
            exito: intento.exito ? '✅' : '❌',
            detalles: intento.resultado
          });
        });

        this.isPrintinginProgress = true
        this.mergedData = this.data.map(originalRow => {
          // Busca la visita correspondiente al registro original
          const visitIndex = this.visitsFromResponse.findIndex(visit => visit.visitLabel === originalRow.visitLabel);
          const visitMatch = this.visitsFromResponse[visitIndex];



          // Devuelve el registro original, combinando los datos y agregando el orden (visitIndex)
          return {
            ...originalRow,
            ...visitMatch,                // fusiona los datos de la visita
            ordenVisita: visitIndex >= 0 ? visitIndex + 1 : null // si lo encontró, usa el índice + 1 (opcional)
          };
        });



        // 1️⃣ Agrupás solo una vez por ruta
        const tareasAgrupadasPorRuta = this.mergedData.reduce((acc, tarea) => {
          const ruta = tarea.nombreRuta;

          if (!acc[ruta]) {
            acc[ruta] = [];
          }

          acc[ruta].push(tarea);

          return acc;
        }, {} as { [key: string]: any[] });

        // 2️⃣ Iniciás el mapa UNA vez (Centro de Colombia en el ejemplo)
        const colombiaCenter = { longitud: 4.5709, latitud: -74.2973 };
        this.initMap(colombiaCenter);


        this.ultimaUbicacionlista = []
        const mapasContainer = document.getElementById('mapas-container');
        mapasContainer.innerHTML = '';

        // 3️⃣ Recorres cada ruta con sus tareas
        for (const ruta in tareasAgrupadasPorRuta) {


          if (tareasAgrupadasPorRuta.hasOwnProperty(ruta)) {

            const colorGen = new ColorGenerator();
            const color = colorGen.generarColorFosforescenteOscuro();

            const tareas = tareasAgrupadasPorRuta[ruta];
            this.ultimaUbicacionlista.push({ usuario: ruta, total: tareas.length })

            const guiadeopereacion = this.visitsFromResponse.filter(tarea => tarea.nombreRuta === ruta);

            if (mapasContainer) {
              const mapWrapper = document.createElement('div');
              mapWrapper.classList.add('mapa-wrapper');

              // Click para seleccionar
              mapWrapper.addEventListener('click', () => {
                document.querySelectorAll('.mapa-wrapper').forEach(card => card.classList.remove('selected'));
                mapWrapper.classList.add('selected');
              });

              const titulo = document.createElement('h3');
              titulo.textContent = `${ruta}`;
              titulo.classList.add('mapa-titulo');

              // Contenedor del mapa y la tabla en columna
              const contentContainer = document.createElement('div');
              contentContainer.classList.add('content-container');

              // Contenedor del mapa
              const mapContainer = document.createElement('div');
              mapContainer.id = `map-${ruta}`;
              mapContainer.classList.add('mapa-container');

              // Contenedor de la tabla
              const tablaContainer = document.createElement('div');
              tablaContainer.classList.add('tabla-container');

              const table = document.createElement('table');
              table.classList.add('styled-table');

              // Encabezados de la tabla
              const thead = document.createElement('thead');
              thead.innerHTML = `
            <tr>
              <th>📌 Tarea</th>
              <th>📍 Tipo</th>
              <th>⏳ Duración</th>
              <th>📦 Carga</th>
              <th>📦 Eta</th>
            </tr>
          `;

              const tbody = document.createElement('tbody');

              // Paginación
              let currentPage = 1;
              const rowsPerPage = 5;
              const totalPages = Math.ceil(guiadeopereacion.length / rowsPerPage);

              const renderTablePage = (page: number) => {
                tbody.innerHTML = "";
                const start = (page - 1) * rowsPerPage;
                const end = start + rowsPerPage;
                const tareasPaginadas = guiadeopereacion.slice(start, end);

                tareasPaginadas.forEach(tarea => {
                  const row = document.createElement('tr');
                  row.innerHTML = `
                <td>${tarea.visitLabel}</td>
                <td>${tarea.type}</td>
                <td>${tarea.duration}</td>
                <td>${tarea.pickups}</td>
                <td>${tarea.eta}</td>
              `;
                  tbody.appendChild(row);
                });

                // Actualizar contador de página
                pageIndicator.textContent = `Página ${currentPage} de ${totalPages} | ${guiadeopereacion.length}`;
              };


              table.appendChild(thead);
              table.appendChild(tbody);
              tablaContainer.appendChild(table);

              // Controles de paginación
              const paginationContainer = document.createElement('div');
              paginationContainer.classList.add('pagination-container');

              const prevButton = document.createElement('button');
              prevButton.textContent = "⬅️ Anterior";
              prevButton.disabled = true;
              prevButton.addEventListener("click", () => {
                if (currentPage > 1) {
                  currentPage--;
                  renderTablePage(currentPage);
                  nextButton.disabled = false;
                  if (currentPage === 1) prevButton.disabled = true;
                }
              });

              const pageIndicator = document.createElement('span');
              pageIndicator.classList.add('page-indicator');

              const nextButton = document.createElement('button');
              nextButton.textContent = "Siguiente ➡️";
              if (guiadeopereacion.length <= rowsPerPage) nextButton.disabled = true;
              nextButton.addEventListener("click", () => {
                if (currentPage < totalPages) {
                  currentPage++;
                  renderTablePage(currentPage);
                  prevButton.disabled = false;
                  if (currentPage === totalPages) nextButton.disabled = true;
                }
              });

              paginationContainer.appendChild(prevButton);
              paginationContainer.appendChild(pageIndicator);
              paginationContainer.appendChild(nextButton);
              tablaContainer.appendChild(paginationContainer);

              // Renderizar la primera página de la tabla
              renderTablePage(currentPage);

              // Agregar mapa y tabla al contenedor principal
              contentContainer.appendChild(mapContainer);
              contentContainer.appendChild(tablaContainer);

              // Agregar elementos al wrapper
              mapWrapper.appendChild(titulo);
              mapWrapper.appendChild(contentContainer);
              mapasContainer.appendChild(mapWrapper);

              // Inicializar el mapa con Google Maps
              
              const mapa = new google.maps.Map(mapContainer, {
                center: { lat: tareas[0].lat, lng: tareas[0].lon },
                zoom: 14,
              });
              
                //ultimo add
              this.addGeozona(tareas, color, mapa);
            }

            // Si querés, agregás otros métodos:
            // this.addMarkers(tareas, color);
          }
        }

        //this.response = response;
        // this.processResponse(response); // Procesar la respuesta
      },
      (error) => {
        console.error('❌ Error:', error);
      }
    );


  }

  obtenerEsquemas() {
    this.resumenService.getEsquemas().subscribe(
      data => {
        this.esquemas = data;

      },
      error => {
        console.error('Error al obtener esquemas', error);
      }
    );
  }





  descargar() {
    const excludedFields = ['geoHere', 'geoGoogle', 'reportes','VRTIA_FindClosestBusinessByName','VRTIA_AddressInit','VRTIA_Domain','VRTIA_AddressNormalized','VRTIA_DistanceBetweenReportAndGoogle','VRTIA_DistanceBetweenSentPointAndGoogle','hereData','VRTIA_DistanceBetweenReportAndHere','DistanceBetweenSentPointAndHere','VRTIA_DistanceBetweenSentPointAndHere','VRTIA_AddressLabelHere','listaConGeo'];
  
    const cleanData = this.data.map(item => {
      const newItem = { ...item }; // clona el objeto
      excludedFields.forEach(field => delete newItem[field]);
      return newItem;
    });
  
    this.exportVisitsToExcel(cleanData);
    // this.exportVisitsToExcelPlan(this.visitsFromResponse);
  }
  location() {


    /*
    this.resumenService.normalizarDireccion("KR 76 #80C - 36 medellin colombia") .subscribe(
      (response) => {

      
        console.log('❌ response normalizarDireccion:', response);
    
        //this.response = response;
       // this.processResponse(response); // Procesar la respuesta
      },
      (error) => {
        console.error('❌ Error:', error);
      }
    );

    

    this.resumenService.validateAddress("Carrera 52 41-102 medellin colombia","Medellin","CO") .subscribe(
      (response) => {

      
        console.log('❌ response validateAddress:', response);
    
        //this.response = response;
       // this.processResponse(response); // Procesar la respuesta
      },
      (error) => {
        console.error('❌ Error:', error);
      }
    );

    this.resumenService.getCoordinates("Carrera 52 41-102 medellin colombia") .subscribe(
      (response) => {

      
        console.log('❌ response getCoordinates:', response);
    
        //this.response = response;
       // this.processResponse(response); // Procesar la respuesta
      },
      (error) => {
        console.error('❌ Error:', error);
      }
    );

    this.resumenService.buscarTareasPorDireccion(negocio,agencia ,"Carrera 52 41-102/Carrera 52 41-102","2025-02-01","2025-04-01") .subscribe(
      (response) => {

      
        console.log('❌ response buscarTareasPorDireccion:', response);
    
        //this.response = response;
       // this.processResponse(response); // Procesar la respuesta
      },
      (error) => {
        console.error('❌ Error:', error);
      }
    );

    */

    this.resumenService.buscarTareasPorDireccion(negocio, agencia, "KR 73 # 93 - 117", "2025-02-01", "2025-04-01").subscribe(
      (response) => {


        console.log('❌ response buscarTareasPorDireccion:', response);

        //this.response = response;
        // this.processResponse(response); // Procesar la respuesta
      },
      (error) => {
        console.error('❌ Error:', error);
      }
    );
  }

  exportVisitsToExcel = (visits: any[]) => {
    const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
  
    if (!visits || visits.length === 0) return;
  
    const headers = Object.keys(visits[0]);
    const data: any[][] = [headers];
  
    visits.forEach((visit) => {
      const row: any[] = [];
  
      headers.forEach((key) => {
        if (key === 'VRTIA_StreetView' && visit[key]) {
          // Crear celda con hipervínculo
          row.push({
            t: 's',                            // tipo string
            v: 'Ver StreetView',              // texto visible
            l: { Target: visit[key] }         // hipervínculo
          });
        } else {
          if (key === 'VRTIA_Place_Url' && visit[key]) {
            // Crear celda con hipervínculo
            row.push({
              t: 's',                            // tipo string
              v: 'Ver Place',              // texto visible
              l: { Target: visit[key] }         // hipervínculo
            });
          } else {
            row.push(visit[key]);
          }
        }
      });
  
      data.push(row);
    });
  
    const worksheet: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet(data);
  
    // Obligatorio: Agregar propiedad !cols para que Excel renderice bien
    worksheet['!cols'] = headers.map(() => ({ wch: 15 }));
  
    const workbook: XLSX.WorkBook = { Sheets: { 'Visits': worksheet }, SheetNames: ['Visits'] };
  
    const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    const blob: Blob = new Blob([excelBuffer], { type: EXCEL_TYPE });
  
    const now = new Date();
    const dateString = `${now.getFullYear()}-${(now.getMonth() + 1).toString().padStart(2, '0')}-${now.getDate().toString().padStart(2, '0')}`;
    const timeString = `${now.getHours().toString().padStart(2, '0')}-${now.getMinutes().toString().padStart(2, '0')}-${now.getSeconds().toString().padStart(2, '0')}`;
    
    const fileName = `vrtia-geo-${dateString}-${timeString}.xlsx`; // Ejemplo: rutas_2025-04-23_15-30-45.xlsx
  
    // Guardar el archivo con el nombre dinámico
    FileSaver.saveAs(blob, fileName);
  };
  
  

  exportVisitsToExcelPlan = (visits: any[]) => {
    const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';

    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(visits);
    const workbook: XLSX.WorkBook = { Sheets: { 'Visits': worksheet }, SheetNames: ['Visits'] };

    const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    const data: Blob = new Blob([excelBuffer], { type: EXCEL_TYPE });

    FileSaver.saveAs(data, 'guiadeoperacion.xlsx');
  };

  processResponse(response: Response | null) {
    if (!response || !response.routes) {
      console.warn('Invalid or empty response');
      return;
    }




    const visitsFromResponse: any[] = [];

    if (response.routes && response.routes.length > 0) {
      response.routes.forEach((route, index) => {
        const nombreRuta = `Ruta ${index + 1}`; // Nombre dinámico para la ruta

        if (route.visits && route.visits.length > 0) {
          console.warn(`La ${nombreRuta} tiene visitas`, route.visits);

          route.visits.forEach(visit => {
            // Agregar el campo nombreRuta a cada visit
            visit.nombreRuta = nombreRuta;

            visitsFromResponse.push(visit);
          });

        } else {
          console.warn(`La ${nombreRuta} no tiene visitas.`);
        }
      });
    } else {
      console.warn('No hay rutas en la respuesta.');
    }

    console.warn('Visitas encontradas:', visitsFromResponse);


    // Exporta la lista que creamos en el paso anterior


    this.mergedData = this.data.map(originalRow => {
      // Busca la visita correspondiente al registro original
      const visitIndex = visitsFromResponse.findIndex(visit => visit.visitLabel === originalRow.visitLabel);
      const visitMatch = visitsFromResponse[visitIndex];



      // Devuelve el registro original, combinando los datos y agregando el orden (visitIndex)
      return {
        ...originalRow,
        ...visitMatch,                // fusiona los datos de la visita
        ordenVisita: visitIndex >= 0 ? visitIndex + 1 : null // si lo encontró, usa el índice + 1 (opcional)
      };
    });



    // 1️⃣ Agrupás solo una vez por ruta
    const tareasAgrupadasPorRuta = this.mergedData.reduce((acc, tarea) => {
      const ruta = tarea.nombreRuta;

      if (!acc[ruta]) {
        acc[ruta] = [];
      }

      acc[ruta].push(tarea);

      return acc;
    }, {} as { [key: string]: any[] });

    // 2️⃣ Iniciás el mapa UNA vez (Centro de Colombia en el ejemplo)
    const colombiaCenter = { longitud: 4.5709, latitud: -74.2973 };
    this.initMap(colombiaCenter);


    this.ultimaUbicacionlista = []

    const mapasContainer = document.getElementById('mapas-container');
    mapasContainer.innerHTML = '';

    // 3️⃣ Recorres cada ruta con sus tareas
    for (const ruta in tareasAgrupadasPorRuta) {


      if (tareasAgrupadasPorRuta.hasOwnProperty(ruta)) {

        const colorGen = new ColorGenerator();
        const color = colorGen.generarColorFosforescenteOscuro();

        const tareas = tareasAgrupadasPorRuta[ruta];
        this.ultimaUbicacionlista.push({ usuario: ruta, total: tareas.length })



        if (mapasContainer) {
          const mapWrapper = document.createElement('div');
          mapWrapper.classList.add('mapa-wrapper');

          // Click para seleccionar
          mapWrapper.addEventListener('click', () => {
            // Quita la clase 'selected' de todas las cards
            document.querySelectorAll('.mapa-wrapper').forEach(card => card.classList.remove('selected'));

            // Agrega la clase solo a esta card
            mapWrapper.classList.add('selected');
          });

          const titulo = document.createElement('h3');
          titulo.textContent = `${ruta}`;
          titulo.classList.add('mapa-titulo');

          const mapContainer = document.createElement('div');
          mapContainer.id = `map-${ruta}`;
          mapContainer.classList.add('mapa-container');

          mapWrapper.appendChild(titulo);
          mapWrapper.appendChild(mapContainer);

          mapasContainer.appendChild(mapWrapper);

          const mapa = new google.maps.Map(mapContainer, {
            center: { lat: tareas[0].lat, lng: tareas[0].lng },
            zoom: 14,
          });

         // this.addGeozona(tareas, color, mapa);
        }




        // Si querés, agregás otros métodos:
        // this.addMarkers(tareas, color);
      }
    }


    // exportVisitsToExcel(mergedData);

    // this.routes = response.routes.map(route => this.mapRoute(route));
  }

  getLocationVehiclePairs(routesData: any[] | null | undefined): { visitLabel: string, nombreRuta: string, type: String, pickups: Number, duration: Number, eta: String }[] {
    // Validar si routesData es null/undefined o no es un array
    if (!routesData || !Array.isArray(routesData)) {
      return [];
    }

    const pairs: { visitLabel: string, nombreRuta: string, type: String, pickups: Number, duration: Number, eta: String }[] = [];

    routesData.forEach(route => {
      // Validar si route es null/undefined o no tiene vehicle/stops
      if (!route || !route.vehicle || !route.stops || !Array.isArray(route.stops)) {
        return; // Continuar con el siguiente elemento
      }

      const vehicleId = route.vehicle;

      route.stops.forEach(stop => {
        // Validar si stop es null/undefined o no tiene location
        if (!stop || !stop.location) {
          return;
        }
        stop.pickups = stop.pickups || [];
        stop.duration = stop.duration || 0;
        pairs.push({
          visitLabel: stop.location,
          nombreRuta: vehicleId,
          type: stop.type,
          pickups: stop.pickups.length,
          duration: stop.duration,
          eta: stop.eta
        });
      });
    });

    return pairs;
  }

  mapRoute(route: Route) {
    return {
      vehicleStartTime: route.vehicleStartTime || '',
      vehicleEndTime: route.vehicleEndTime || '',
      visits: this.mapVisits(route.visits),
      transitions: this.mapTransitions(route.transitions),
      metrics: this.mapMetrics(route.metrics),
      routeCosts: route.routeCosts || [],
      routeTotalCost: route.routeTotalCost || 0,
    };
  }

  mapVisits(visits: Visit[]) {
    if (!visits) return [];
    return visits.map(visit => ({
      isPickup: visit.isPickup || false,
      startTime: visit.startTime || '',
      detour: visit.detour || 0,
    }));
  }

  mapTransitions(transitions: Transition[]) {
    if (!transitions) return [];
    return transitions.map(transition => ({
      travelDuration: transition.travelDuration || '',
      travelDistanceMeters: transition.travelDistanceMeters || 0,
      waitDuration: transition.waitDuration || '',
      totalDuration: transition.totalDuration || '',
      startTime: transition.startTime || '',
    }));
  }

  mapMetrics(metrics: Metrics) {
    if (!metrics) return {} as Metrics;
    return {
      performedShipmentCount: metrics.performedShipmentCount || 0,
      travelDuration: metrics.travelDuration || '',
      waitDuration: metrics.waitDuration || '',
      delayDuration: metrics.delayDuration || '',
      breakDuration: metrics.breakDuration || '',
      visitDuration: metrics.visitDuration || '',
      totalDuration: metrics.totalDuration || '',
      travelDistanceMeters: metrics.travelDistanceMeters || 0,
    };
  }

  ngOnInit() {
    this.obtenerEsquemas()

    const colombiaCenter = { longitud: 4.5709, latitud: -74.2973 }; // 🔹 Centro de Colombia
    this.initMap(colombiaCenter);

  }

  ngAfterViewInit(): void {
    negocio = localStorage.getItem("negocio");
    agencia = localStorage.getItem("agencia");
    const colorGen = new ColorGenerator();

    const colombiaCenter = { longitud: 4.5709, latitud: -74.2973 }; // 🔹 Centro de Colombia
    this.initMap(colombiaCenter);

    this.dataSource.paginator = this.paginator;
    /*
    this.resumenService.optimizeRoutes(this.vehicles, this.shipments).subscribe({
      next: (data) => {
        console.log('✅ Optimización recibida:', data);
        this.result = data;

        data.routes.forEach(route => {
          console.log("Vehículo sale:", route.vehicleStartTime);
          console.log("Vehículo termina:", route.vehicleEndTime);
        });

        data.visits.forEach((visit, index) => {
          const action = visit.isPickup ? "Recolectar" : "Entregar";
          console.log(`#${index + 1}: ${action} a las ${visit.startTime}`);
        });
      },
      error: (err) => {
        console.error('❌ Error al optimizar:', err);
        this.error = err;
      }
    });

  */

    // Llamar al servicio para obtener las ubicaciones




  }

  initMap(center: any): void {
    /*
    const options: google.maps.MapOptions = {
      center: { lat: center.longitud, lng: center.latitud }, // 🔹 Centro en Colombia
      zoom: 6 // 🔹 Zoom inicial (ajusta según sea necesario)
  };

    this.map = new google.maps.Map(this.mapContainer.nativeElement, options);

    console.error('❌ Error al optimizar: ingreso');
    */
  }

  initMapFilter(center: any): void {

    /*
    const options: google.maps.MapOptions = {
      center: { lat: center.latitud, lng: center.longitud }, // 🔹 Centro en Colombia
      zoom: 13 // 🔹 Zoom inicial (ajusta según sea necesario)
   
  };

    this.map = new google.maps.Map(this.mapContainer.nativeElement, options);

    console.error('❌ Error al optimizar: ingreso');
       */
  }
  toggleTodos() {
    if (this.seleccionarTodos) {
      this.usuarioSeleccionado = null; // Se desmarca cualquier selección individual
    }

  }

  // Verifica si el checkbox "Seleccionar Todos" debe estar activado o no
  verificarSeleccion() {
    if (this.usuarioSeleccionado) {
      this.seleccionarTodos = false; // Si seleccionas un usuario, desmarca "Seleccionar Todos"
    }



  }




  addGeozona(recorridos: any[], color: String, mapa: google.maps.Map): void {

    console.log("recorridos", recorridos)
    const sortedRecorridos = [...recorridos].sort((a, b) =>
      new Date(a.eta).getTime() - new Date(b.eta).getTime()
    );

    // 🔹 Asignar ordenTarea basado en la posición en la lista ordenada
    sortedRecorridos.forEach((location, index) => {
      location.ordenTarea = index + 1; // Comienza desde 1
    });


    const points: PuntoConOrden[] = recorridos.map((location, index) => ({
      lat: parseFloat(location.lat),
      lng: parseFloat(location.lon),
      ordenVisita: location.ordenVisita,
      ordenTarea: location.ordenTarea
    }));



    // 🔹 1. Calcular el Convex Hull (envolvente convexa)
    const geozonaCoords = this.geoManager.createConvexHull(points);


    // 🔹 3. Dibujar la geozona en el mapa
    const geozona = new google.maps.Polygon({
      paths: geozonaCoords,
      strokeColor: color,
      strokeOpacity: 0.8,
      strokeWeight: 2,
      fillColor: color,
      fillOpacity: 0.3
    });

    geozona.setMap(mapa);



    recorridos.forEach((location: any) => {


      const marker = new google.maps.Marker({
        position: { lat: location.lat, lng: location.lon },
        map: mapa,
        icon: {
          path: google.maps.SymbolPath.CIRCLE,
          fillColor: color,
          fillOpacity: 0.8,
          strokeColor: color,
          strokeWeight: 1,
          scale: 10, // Tamaño del círculo
        }
      });




      marker.addListener("click", () => {
        mapa.setCenter(marker.getPosition() as google.maps.LatLng);
        mapa.setZoom(14); // Nivel de zoom al hacer clic
      });


      new google.maps.Marker({
        position: { lat: location.lat, lng: location.lon },
        map: mapa,
        label: {
          text: location.ordenTarea.toString(), // Muestra el número en el centro
          color: "#000", // Color del número
          fontSize: "8px",
          fontWeight: "normal",
        },
        icon: {
          path: google.maps.SymbolPath.CIRCLE,
          scale: 0, // Hace invisible el ícono, solo se verá el texto
        }
      });


    });

    const esquemaObj = this.esquemas.find(e => e.id === this.esquemaSeleccionado);
    const init = [esquemaObj.modeloGestion.modelo.longitudInicial, esquemaObj.modeloGestion.modelo.latitudInicial]
    const iconUrl = 'assets/trackrojo.svg'; // 🔹 Reemplaza con la URL de tu icono



    const marker = new google.maps.Marker({
      position: { lat: esquemaObj.modeloGestion.modelo.latitudInicial, lng: esquemaObj.modeloGestion.modelo.longitudInicial }, // 🔹 Asegúrate de que lat y lng estén en el orden correcto
      map: mapa,
      title: "",
      icon: {
        url: iconUrl, // 🔹 URL del icono personalizado
        scaledSize: new google.maps.Size(30, 30) // 🔹 Tamaño del icono (ancho, alto)
      }
    });


  }



  consultarFecha() {



    if (this.seleccionarTodos) {
      ///

      // 1️⃣ Agrupás solo una vez por ruta
      const tareasAgrupadasPorRuta = this.mergedData.reduce((acc, tarea) => {
        const ruta = tarea.nombreRuta;

        if (!acc[ruta]) {
          acc[ruta] = [];
        }

        acc[ruta].push(tarea);

        return acc;
      }, {} as { [key: string]: any[] });

      // 2️⃣ Iniciás el mapa UNA vez (Centro de Colombia en el ejemplo)
      const colombiaCenter = { longitud: 4.5709, latitud: -74.2973 };
      this.initMap(colombiaCenter);


      this.ultimaUbicacionlista = []
      console.log('Tareas en la tareasAgrupadasPorRuta:', tareasAgrupadasPorRuta);
      const mapasContainer = document.getElementById('mapas-container');
      mapasContainer.innerHTML = '';

      // 3️⃣ Recorres cada ruta con sus tareas
      for (const ruta in tareasAgrupadasPorRuta) {


        if (tareasAgrupadasPorRuta.hasOwnProperty(ruta)) {

          const colorGen = new ColorGenerator();
          const color = colorGen.generarColorFosforescenteOscuro();

          const tareas = tareasAgrupadasPorRuta[ruta];
          this.ultimaUbicacionlista.push({ usuario: ruta, total: tareas.length })
          console.log('Ruta:', ruta);
          console.log('Tareas en la ruta:', tareas);


          const guiadeopereacion = this.visitsFromResponse.filter(tarea => tarea.nombreRuta === ruta);
          console.log('Tareas guiadeopereacion', guiadeopereacion);

          if (mapasContainer) {
            const mapWrapper = document.createElement('div');
            mapWrapper.classList.add('mapa-wrapper');

            // Click para seleccionar
            mapWrapper.addEventListener('click', () => {
              document.querySelectorAll('.mapa-wrapper').forEach(card => card.classList.remove('selected'));
              mapWrapper.classList.add('selected');
            });

            const titulo = document.createElement('h3');
            titulo.textContent = `${ruta}`;
            titulo.classList.add('mapa-titulo');

            // Contenedor del mapa y la tabla en columna
            const contentContainer = document.createElement('div');
            contentContainer.classList.add('content-container');

            // Contenedor del mapa
            const mapContainer = document.createElement('div');
            mapContainer.id = `map-${ruta}`;
            mapContainer.classList.add('mapa-container');

            // Contenedor de la tabla
            const tablaContainer = document.createElement('div');
            tablaContainer.classList.add('tabla-container');

            const table = document.createElement('table');
            table.classList.add('styled-table');

            // Encabezados de la tabla
            const thead = document.createElement('thead');
            thead.innerHTML = `
                <tr>
                  <th>📌 Tarea</th>
                  <th>📍 Tipo</th>
                  <th>⏳ Duración</th>
                  <th>📦 Carga</th>
                  <th>📦 Eta</th>
                </tr>
              `;

            const tbody = document.createElement('tbody');

            // Paginación
            let currentPage = 1;
            const rowsPerPage = 5;
            const totalPages = Math.ceil(guiadeopereacion.length / rowsPerPage);

            const renderTablePage = (page: number) => {
              tbody.innerHTML = "";
              const start = (page - 1) * rowsPerPage;
              const end = start + rowsPerPage;
              const tareasPaginadas = guiadeopereacion.slice(start, end);

              tareasPaginadas.forEach(tarea => {
                const row = document.createElement('tr');
                row.innerHTML = `
                    <td>${tarea.visitLabel}</td>
                    <td>${tarea.type}</td>
                    <td>${tarea.duration}</td>
                    <td>${tarea.pickups}</td>
                    <td>${tarea.eta}</td>
                  `;
                tbody.appendChild(row);
              });

              // Actualizar contador de página
              pageIndicator.textContent = `Página ${currentPage} de ${totalPages} | ${guiadeopereacion.length}`;
            };


            table.appendChild(thead);
            table.appendChild(tbody);
            tablaContainer.appendChild(table);

            // Controles de paginación
            const paginationContainer = document.createElement('div');
            paginationContainer.classList.add('pagination-container');

            const prevButton = document.createElement('button');
            prevButton.textContent = "⬅️ Anterior";
            prevButton.disabled = true;
            prevButton.addEventListener("click", () => {
              if (currentPage > 1) {
                currentPage--;
                renderTablePage(currentPage);
                nextButton.disabled = false;
                if (currentPage === 1) prevButton.disabled = true;
              }
            });

            const pageIndicator = document.createElement('span');
            pageIndicator.classList.add('page-indicator');

            const nextButton = document.createElement('button');
            nextButton.textContent = "Siguiente ➡️";
            if (guiadeopereacion.length <= rowsPerPage) nextButton.disabled = true;
            nextButton.addEventListener("click", () => {
              if (currentPage < totalPages) {
                currentPage++;
                renderTablePage(currentPage);
                prevButton.disabled = false;
                if (currentPage === totalPages) nextButton.disabled = true;
              }
            });

            paginationContainer.appendChild(prevButton);
            paginationContainer.appendChild(pageIndicator);
            paginationContainer.appendChild(nextButton);
            tablaContainer.appendChild(paginationContainer);

            // Renderizar la primera página de la tabla
            renderTablePage(currentPage);

            // Agregar mapa y tabla al contenedor principal
            contentContainer.appendChild(mapContainer);
            contentContainer.appendChild(tablaContainer);

            // Agregar elementos al wrapper
            mapWrapper.appendChild(titulo);
            mapWrapper.appendChild(contentContainer);
            mapasContainer.appendChild(mapWrapper);

            // Inicializar el mapa con Google Maps
            const mapa = new google.maps.Map(mapContainer, {
              center: { lat: tareas[0].lat, lng: tareas[0].lon },
              zoom: 14,
            });

            this.addGeozona(tareas, color, mapa);
          }








          // Si querés, agregás otros métodos:
          // this.addMarkers(tareas, color);
        }
      }

      ///
    } else {
      console.error("El valor no es un arreglo o está this.usuarioSeleccionado.usuario:", this.usuarioSeleccionado.usuario);

      const datosFiltrados = this.mergedData.filter((item) => item.nombreRuta === this.usuarioSeleccionado.usuario);


      if (Array.isArray(datosFiltrados) && datosFiltrados.length > 0) {


        // Filtrar ubicaciones con coordenadas válidas
        console.error("El ubicaciones:", datosFiltrados);




        if (datosFiltrados.length > 0) {
          // Obtener las coordenadas del primer ítem
          const primerItem = datosFiltrados[0];
          const coordenadasPrimerItem = { latitud: primerItem.lat, longitud: primerItem.lon };

          // Inicializar el mapa en la posición del primer ítem
          this.initMapFilter(coordenadasPrimerItem);
        } else {
          console.error('No hay datos filtrados para mostrar.');
        }


        const colorGen = new ColorGenerator();
        const color = colorGen.generarColorFosforescenteOscuro();

        const guiadeopereacion = this.visitsFromResponse.filter(tarea => tarea.nombreRuta === this.usuarioSeleccionado.usuario);
        console.log('Tareas guiadeopereacion', guiadeopereacion);

        const mapasContainer = document.getElementById('mapas-container');
        mapasContainer.innerHTML = '';
        if (mapasContainer) {
          const mapWrapper = document.createElement('div');
          mapWrapper.classList.add('mapa-wrapperdos');

          // Click para seleccionar
          mapWrapper.addEventListener('click', () => {
            document.querySelectorAll('.mapa-wrapperdos').forEach(card => card.classList.remove('selected'));
            mapWrapper.classList.add('selected');
          });

          const titulo = document.createElement('h3');
          titulo.textContent = `${this.usuarioSeleccionado.usuario}`;
          titulo.classList.add('mapa-titulo');

          // Contenedor del mapa y la tabla en columna
          const contentContainer = document.createElement('div');
          contentContainer.classList.add('content-container');

          // Contenedor del mapa
          const mapContainer = document.createElement('div');
          mapContainer.id = `map-${this.usuarioSeleccionado.usuario}`;
          mapContainer.classList.add('mapa-container');

          // Contenedor de la tabla
          const tablaContainer = document.createElement('div');
          tablaContainer.classList.add('tabla-container');

          const table = document.createElement('table');
          table.classList.add('styled-table');

          // Encabezados de la tabla
          const thead = document.createElement('thead');
          thead.innerHTML = `
            <tr>
              <th>📌 Tarea</th>
              <th>📍 Tipo</th>
              <th>⏳ Duración</th>
              <th>📦 Carga</th>
              <th>📦 Eta</th>
            </tr>
          `;

          const tbody = document.createElement('tbody');

          // Paginación
          let currentPage = 1;
          const rowsPerPage = 5;
          const totalPages = Math.ceil(guiadeopereacion.length / rowsPerPage);

          const renderTablePage = (page: number) => {
            tbody.innerHTML = "";
            const start = (page - 1) * rowsPerPage;
            const end = start + rowsPerPage;
            const tareasPaginadas = guiadeopereacion.slice(start, end);

            tareasPaginadas.forEach(tarea => {
              const row = document.createElement('tr');
              row.innerHTML = `
                <td>${tarea.visitLabel}</td>
                <td>${tarea.type}</td>
                <td>${tarea.duration}</td>
                <td>${tarea.pickups}</td>
                <td>${tarea.eta}</td>
              `;
              tbody.appendChild(row);
            });

            // Actualizar contador de página
            pageIndicator.textContent = `Página ${currentPage} de ${totalPages} | ${guiadeopereacion.length}`;
          };


          table.appendChild(thead);
          table.appendChild(tbody);
          tablaContainer.appendChild(table);

          // Controles de paginación
          const paginationContainer = document.createElement('div');
          paginationContainer.classList.add('pagination-container');

          const prevButton = document.createElement('button');
          prevButton.textContent = "⬅️ Anterior";
          prevButton.disabled = true;
          prevButton.addEventListener("click", () => {
            if (currentPage > 1) {
              currentPage--;
              renderTablePage(currentPage);
              nextButton.disabled = false;
              if (currentPage === 1) prevButton.disabled = true;
            }
          });

          const pageIndicator = document.createElement('span');
          pageIndicator.classList.add('page-indicator');

          const nextButton = document.createElement('button');
          nextButton.textContent = "Siguiente ➡️";
          if (guiadeopereacion.length <= rowsPerPage) nextButton.disabled = true;
          nextButton.addEventListener("click", () => {
            if (currentPage < totalPages) {
              currentPage++;
              renderTablePage(currentPage);
              prevButton.disabled = false;
              if (currentPage === totalPages) nextButton.disabled = true;
            }
          });

          paginationContainer.appendChild(prevButton);
          paginationContainer.appendChild(pageIndicator);
          paginationContainer.appendChild(nextButton);
          tablaContainer.appendChild(paginationContainer);

          // Renderizar la primera página de la tabla
          renderTablePage(currentPage);

          // Agregar mapa y tabla al contenedor principal
          contentContainer.appendChild(mapContainer);
          contentContainer.appendChild(tablaContainer);

          // Agregar elementos al wrapper
          mapWrapper.appendChild(titulo);
          mapWrapper.appendChild(contentContainer);
          mapasContainer.appendChild(mapWrapper);

          // Inicializar el mapa con Google Maps
          const mapa = new google.maps.Map(mapContainer, {
            center: { lat: datosFiltrados[0].lat, lng: datosFiltrados[0].lon },
            zoom: 14,
          });

         // this.addGeozona(datosFiltrados, color, mapa);
          this.calcularRutaConWaypoints(datosFiltrados, mapa)

        }
        // Acá pasás las tareas de la ruta al método que quieras


      } else {
        console.error("El valor no es un arreglo o está vacío:", datosFiltrados);
      }


    }





  }

  onEsquemaChange() {
    this.esquemasView = []
    console.log('ID del esquema seleccionado:', this.esquemaSeleccionado);

    // Si quieres obtener todo el objeto del esquema, haz esto:
    const esquemaObj = this.esquemas.find(e => e.id === this.esquemaSeleccionado);
    this.esquemasView.push(esquemaObj)
    console.log('Objeto esquema seleccionado:', esquemaObj);

    const hoy = new Date();

    // Obtener la fecha en formato YYYY-MM-DD
    const fechaISO = hoy.toISOString().split('T')[0];

    // Construir fecha completa en UTC con la hora de inicio y fin
    // Construir fechas con la hora del modelo en UTC
    const earliest_start = new Date(`${fechaISO}T${esquemaObj.modeloGestion.modelo.horaInicio}:00Z`).toISOString();
    const latest_end = new Date(`${fechaISO}T${esquemaObj.modeloGestion.modelo.horaFinal}:00Z`).toISOString();

    var tipo = 2; // Valor por defecto (paquete)
    if (this.criterioReabastecimiento == "peso") {
      tipo = 1;
    } else if (this.criterioReabastecimiento == "volumen") {
      tipo = 3;
    }


    if (this.permitirReabastecimiento) {
      this.vehiclesesquemaview = esquemaObj.recursos.flatMap((recurso: any, index: number) =>
        Array.from({ length: recurso.cantidad }, (_, i) => ({
          name: recurso.nombre + " " + (index + i).toString(),
          routing_profile: "mapbox/driving-traffic", // Generar un identificador único basado en el índice
          capacities: {
            amount: this.getCapacidadSegunTipo(recurso.recurso, tipo)
          }, // Capacidad por unidad
          earliest_start,
          latest_end,
          start_location: "init",
          end_location: "end",
        }))
      );



      console.error(' vehiclesesquema', this.vehiclesesquemaview);
    } else {
      this.vehiclesesquemaview = esquemaObj.recursos.flatMap((recurso: any, index: number) =>
        Array.from({ length: recurso.cantidad }, (_, i) => ({
          name: recurso.nombre + " " + (index + i).toString(),
          routing_profile: "mapbox/driving-traffic", // Generar un identificador único basado en el índice
          capacities: {
            amount: this.getCapacidadSegunTipo(recurso.recurso, tipo)
          }, // Capacidad por unidad
          earliest_start,
          latest_end,
          start_location: "init",
          end_location: "end",
          capabilities: [
            recurso.nombre + " " + (index + i).toString()
          ]
        }))
      );


      this.calcularVehiculosNecesariosView()
      console.error(' vehiclesesquema', this.vehiclesesquemaview);
    }

    /*
    "capabilities": [
      "ladder",
      "refrigeration"
  ],

  */

  }

  getCapacidadSegunTipo(recurso: any, tipo: number): number {
    switch (tipo) {
      case 1: // Peso
        return recurso.weight || 0; // Usar el peso del recurso
      case 2: // Paquete (valor por defecto)
        return recurso.boxes || 0; // Usar la cantidad de paquetes
      case 3: // Volumen
        return recurso.volume || 0; // Usar el volumen del recurso
      default:
        return recurso.boxes || 0; // Default a paquetes
    }
  }





  calcularRutaConWaypoints(ubicaciones: any[], mapa: google.maps.Map): void {
    const chunkSize = 23; // Máximo de waypoints por solicitud
    const waypointsChunks = chunkArray(ubicaciones.slice(1, -1), chunkSize); // Excluir origen y destino
    console.error('❌ Error al optimizar: ubicaciones', ubicaciones);
    const origin = `${ubicaciones[0].Latitude},${ubicaciones[0].Longitude}`; // Origen
    const destination = `${ubicaciones[ubicaciones.length - 1].Latitude},${ubicaciones[ubicaciones.length - 1].Longitude}`; // Destino

    waypointsChunks.forEach((waypointsChunk, index) => {
      const waypoints = waypointsChunk.map((ubicacion) => `${ubicacion.Latitude},${ubicacion.Longitude}`);


      this.resumenService.getRoute(origin, destination, waypoints).subscribe((response: any) => {
        if (response.status === 'OK') {
          const overviewPolyline = response.routes[0].overview_polyline.points;
          const coordenadas = this.decodePolyline(overviewPolyline); // Decodifica la polilínea

          // Dibuja la ruta en el mapa
          const ruta = new google.maps.Polyline({
            path: coordenadas,
            geodesic: true,
            strokeColor: 'red',
            strokeOpacity: 1.0,
            strokeWeight: 1,
          });

          ruta.setMap(mapa);
        } else {
          console.error(`Error al calcular la ruta (grupo ${index + 1}):`, response.status);
        }
      });

    });
  }

  calcularRutados(): void {

  }


  decodePolyline(encoded: string): { lat: number; lng: number }[] {
    let index = 0;
    const len = encoded.length;
    const array: { lat: number; lng: number }[] = [];
    let lat = 0;
    let lng = 0;

    while (index < len) {
      let b: number;
      let shift = 0;
      let result = 0;

      do {
        b = encoded.charCodeAt(index++) - 63;
        result |= (b & 0x1f) << shift;
        shift += 5;
      } while (b >= 0x20);

      const dlat = (result & 1) !== 0 ? ~(result >> 1) : result >> 1;
      lat += dlat;

      shift = 0;
      result = 0;

      do {
        b = encoded.charCodeAt(index++) - 63;
        result |= (b & 0x1f) << shift;
        shift += 5;
      } while (b >= 0x20);

      const dlng = (result & 1) !== 0 ? ~(result >> 1) : result >> 1;
      lng += dlng;

      array.push({ lat: lat * 1e-5, lng: lng * 1e-5 });
    }

    return array;
  }

  filterOutliers(points: google.maps.LatLngLiteral[]): google.maps.LatLngLiteral[] {
    const lngValues = points.map((p) => p.lng);
    const latValues = points.map((p) => p.lat);

    const lngMean = lngValues.reduce((a, b) => a + b, 0) / lngValues.length;
    const latMean = latValues.reduce((a, b) => a + b, 0) / latValues.length;

    const lngStdDev = Math.sqrt(lngValues.map((x) => Math.pow(x - lngMean, 2)).reduce((a, b) => a + b) / lngValues.length);
    const latStdDev = Math.sqrt(latValues.map((x) => Math.pow(x - latMean, 2)).reduce((a, b) => a + b) / latValues.length);

    return points.filter((p) => {
      const zLng = Math.abs((p.lng - lngMean) / lngStdDev);
      const zLat = Math.abs((p.lat - latMean) / latStdDev);
      return zLng < 2 && zLat < 2; // Ajusta este umbral
    });
  }

  createConcaveHull(points: PuntoConOrden[]): google.maps.LatLngLiteral[] {


    const outsideFeatures = points
      .map((point) => {
        try {
          return turf.point([point.lng, point.lat]);
        } catch (error) {
          console.error('Error al crear el punto:', point, error);
          return null; // Omitir el punto problemático
        }
      })
      .filter(Boolean); // Filtra los puntos nulos

    console.log('Features para convex hull:', outsideFeatures);

    if (points.length < 3) return points;

    const turf = require('@turf/turf');
    console.error('❌ Error al optimizar: 1');
    // Ordenar puntos por ordenVisita
    const puntosOrdenados = this.ordenarPorVisita(points);
    console.error('❌ Error al optimizar: 2');
    // Conectar puntos en el orden de visita
    const maxDistance = 0.1; // Ajusta este valor (en km)
    const puntosConectados = this.conectarPuntosEnOrden(puntosOrdenados, maxDistance);
    console.error('❌ Error al optimizar: 3');
    // Filtra puntos atípicos
    const filteredPoints = this.filterOutliers(puntosConectados);
    console.error('❌ Error al optimizar: 4');
    const pointsGeoJSON = turf.featureCollection(
      filteredPoints.map((point: any) => turf.point([point.lng, point.lat]))
    );

    const options = { maxEdge: 0.3 }; // Ajusta este valor
    const concaveHull = turf.concave(pointsGeoJSON, options);


    console.error('❌ Error al optimizar: 5');
    if (!concaveHull) {
      //const convex = turf.convex(pointsGeoJSON);

      let convex;
      try {
        convex = turf.convex(pointsGeoJSON);
        console.log('Convex hull generado:', convex);
      } catch (error) {
        console.error('Error al generar el convex hull:', error);

        convex = this.geoManager.createConvexHull(points);
        console.log('Convex hull generado con createConvexHull:', convex);
      }
      return convex.geometry.coordinates[0].map((coord: any) => ({
        lng: coord[0],
        lat: coord[1]
      }));
    }
    console.error('❌ Error al optimizar: 6');
    // Verifica si hay puntos fuera del concave hull
    const pointsOutside = points.filter((point) => !turf.booleanPointInPolygon(turf.point([point.lng, point.lat]), concaveHull));
    console.error('❌ Error al optimizar: 7');
    if (pointsOutside.length > 0) {


      const outsideFeatures = pointsOutside.map((point: any) => {
        if (!point.lng || !point.lat) {
          console.error('Punto inválido:', point);
          return null;
        }
        return turf.point([point.lng, point.lat]);
      }).filter(Boolean); // Filtra puntos nulos

      console.log('Features para convex hull:', outsideFeatures);

      if (outsideFeatures.length < 3) {
        console.error('Se necesitan al menos 3 puntos válidos para generar un convex hull.');
        return concaveHull.geometry.coordinates[0].map((coord: any) => ({
          lng: coord[0],
          lat: coord[1],
        }));
      }

      const outsideGeoJSON = turf.featureCollection(outsideFeatures);
      console.log('GeoJSON para convex hull:', outsideGeoJSON);


      const convexHull = turf.convex(turf.featureCollection(
        pointsOutside.map((point: any) => turf.point([point.lng, point.lat]))
      ));


      console.error('❌ Error al optimizar: 7.5', convexHull);
      const combinedHull = turf.union(concaveHull, convexHull);

      console.error('❌ Error al optimizar: 8', combinedHull);
      return combinedHull.geometry.coordinates[0].map((coord: any) => ({
        lng: coord[0],
        lat: coord[1]
      }));

    }

    return concaveHull.geometry.coordinates[0].map((coord: any) => ({
      lng: coord[0],
      lat: coord[1]
    }));
  }

  // Función para ordenar puntos por ordenVisita
  ordenarPorVisita(points: PuntoConOrden[]): PuntoConOrden[] {
    return points.sort((a, b) => a.ordenVisita - b.ordenVisita);
  }

  // Función para conectar puntos en el orden de visita
  conectarPuntosEnOrden(points: PuntoConOrden[], maxDistance: number): google.maps.LatLngLiteral[] {
    const connectedPoints: google.maps.LatLngLiteral[] = [];
    for (let i = 0; i < points.length - 1; i++) {
      const currentPoint = points[i];
      const nextPoint = points[i + 1];
      const interpolated = this.interpolatePoints(currentPoint, nextPoint, maxDistance);
      connectedPoints.push(...interpolated);
    }
    // Cierra el polígono conectando el último punto con el primero
    const interpolated = this.interpolatePoints(points[points.length - 1], points[0], maxDistance);
    connectedPoints.push(...interpolated);
    return connectedPoints;
  }

  // Función para interpolar puntos
  interpolatePoints(point1: google.maps.LatLngLiteral, point2: google.maps.LatLngLiteral, maxDistance: number): google.maps.LatLngLiteral[] {
    const distance = this.calculateDistance(point1, point2);
    if (distance <= maxDistance) {
      return [point1, point2];
    }

    const numPoints = Math.ceil(distance / maxDistance);
    const interpolatedPoints = [];
    for (let i = 0; i <= numPoints; i++) {
      const fraction = i / numPoints;
      const lat = point1.lat + fraction * (point2.lat - point1.lat);
      const lng = point1.lng + fraction * (point2.lng - point1.lng);
      interpolatedPoints.push({ lat, lng });
    }
    return interpolatedPoints;
  }

  // Función para calcular la distancia entre dos puntos
  calculateDistance(point1: google.maps.LatLngLiteral, point2: google.maps.LatLngLiteral): number {
    const R = 6371; // Radio de la Tierra en km
    const dLat = (point2.lat - point1.lat) * (Math.PI / 180);
    const dLng = (point2.lng - point1.lng) * (Math.PI / 180);
    const a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(point1.lat * (Math.PI / 180)) * Math.cos(point2.lat * (Math.PI / 180)) *
      Math.sin(dLng / 2) * Math.sin(dLng / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    return R * c; // Distancia en km
  }

  validarYConvertirCoordenada(valor: any): number | null {
    // Convierte el valor a número
    const numero = parseFloat(valor);

    // Verifica si el valor es un número finito
    if (isNaN(numero) || !isFinite(numero)) {
      console.error('Coordenada inválida:', valor);
      return null;
    }

    return numero;
  }
  validarYConvertirPuntos(puntos: any[]): { lng: number; lat: number }[] {
    return puntos
      .map((punto) => {
        const lng = this.validarYConvertirCoordenada(punto.lng);
        const lat = this.validarYConvertirCoordenada(punto.lat);

        // Si alguna coordenada es inválida, descarta el punto
        if (lng === null || lat === null) {
          console.error('Punto inválido descartado:', punto);
          return null;
        }

        return { lng, lat };
      })
      .filter(Boolean); // Filtra puntos nulos
  }

  convertDecimalToTime(decimalHour: number): string {
    const hours = Math.floor(decimalHour);
    const minutesDecimal = (decimalHour - hours) * 60;
    const minutes = Math.floor(minutesDecimal);
    const secondsDecimal = (minutesDecimal - minutes) * 60;
    const seconds = Math.round(secondsDecimal);

    return `${this.pad(hours)}:${this.pad(minutes)}:${this.pad(seconds)}`;
  }

  pad(value: number): string {
    return value < 10 ? `0${value}` : `${value}`;
  }

  onDateChange(event: Event) {
    const input = event.target as HTMLInputElement;
    const selectedDate = input.value;


    // Aquí puedes filtrar los datos de los marcadores según la fecha seleccionada
    this.updateMarkersByDate(selectedDate);
  }

  updateMarkersByDate(date: string) {
    // 🔹 Filtra los datos que coincidan con la fecha seleccionada y actualiza el mapa

  }



  drawDottedLine(map: google.maps.Map, start: google.maps.LatLngLiteral, end: google.maps.LatLngLiteral, steps: number = 10) {
    const line = new google.maps.Polyline({
      path: [start, end],
      geodesic: true,
      strokeOpacity: 0, // 🔹 Oculta la línea principal
      icons: [{
        icon: {
          path: google.maps.SymbolPath.BACKWARD_CLOSED_ARROW,
          scale: 1, // 🔹 Aumenta el tamaño de la flecha
          strokeOpacity: 1,
          strokeWeight: 2,
          fillOpacity: 1,
          fillColor: "#FF0000"
        },
        offset: "0",
        repeat: "10px" // 🔹 Mayor distancia entre flechas
      }],
      map: map
    });
  }
  calcularVehiculosNecesarios(
    vehiculos: any[],
    carga: { boxes: number }
  ): {
    cumple: boolean;
    vehiculosNecesarios: number;
    vehiculosSeleccionados: any[];
    vehiculosNuevos: any[]; // Lista separada para nuevos vehículos
    vehiculosNoUtilizados: any[];
    totalBoxes: number;
    cargaRequerida: number;
    capacidadFaltante: number;
  } {
    let totalBoxes = 0;
    let count = 0;
    let vehiculosSeleccionados: any[] = [];
    let vehiculosNoUtilizados: any[] = [];
    let vehiculosNuevos: any[] = [];
    let capacidadFaltante = 0;

    // Copia y ordenamiento
    const vehiculosDisponibles = [...vehiculos].sort((a, b) => b.capacities.amount - a.capacities.amount);

    // Procesar vehículos existentes
    for (const vehiculo of vehiculosDisponibles) {
      if (totalBoxes >= carga.boxes) {
        vehiculosNoUtilizados.push(vehiculo);
        continue;
      }
      totalBoxes += vehiculo.capacities.amount;
      vehiculosSeleccionados.push(vehiculo);
      count++;
    }

    // Manejar capacidad faltante
    capacidadFaltante = Math.max(0, carga.boxes - totalBoxes);

    if (capacidadFaltante > 0) {
      const nuevoVehiculo = this.crearNuevoVehiculo(capacidadFaltante);
      vehiculosNuevos.push(nuevoVehiculo);
      totalBoxes += nuevoVehiculo.capacities.amount;
      count++;
    }

    return {
      cumple: totalBoxes >= carga.boxes,
      vehiculosNecesarios: count,
      vehiculosSeleccionados, // Solo vehículos existentes
      vehiculosNuevos,       // Solo vehículos nuevos
      vehiculosNoUtilizados,
      totalBoxes,
      cargaRequerida: carga.boxes,
      capacidadFaltante
    };
  }

  private crearNuevoVehiculo(capacidadNecesaria: number): any {

    return {
      name: `CAMION ${capacidadNecesaria} EXTRA`,
      routing_profile: "mapbox/driving-traffic",
      capacities: { amount: capacidadNecesaria },
      earliest_start: "2025-03-31T08:00:00.000Z",
      latest_end: "2025-03-31T18:00:00.000Z",
      start_location: "init",
      end_location: "end",
      capabilities: [`CAMION_${capacidadNecesaria}_EXTRA`]
    };
  }



  generarColorFosforescenteOscuro(): string {

    const baseColors = [
      [180, 30, 30],  // Rojo profundo
      [30, 180, 30],  // Verde intenso
      [30, 30, 180],  // Azul eléctrico
      [160, 30, 160], // Púrpura oscuro
      [30, 160, 160], // Cian profundo
      [180, 100, 30]  // Naranja oscuro
    ];

    // Selecciona un color base aleatorio
    const base = baseColors[Math.floor(Math.random() * baseColors.length)];

    // Genera una variación fuerte dentro de un rango oscuro
    const r = Math.max(30, Math.min(200, base[0] + Math.floor(Math.random() * 80 - 40)));
    const g = Math.max(30, Math.min(200, base[1] + Math.floor(Math.random() * 80 - 40)));
    const b = Math.max(30, Math.min(200, base[2] + Math.floor(Math.random() * 80 - 40)));
    const alpha = 0.9; // Mantiene alta opacidad pero con un leve toque translúcido

    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
  }

}

class ColorGenerator {
  private usedColors: Set<string> = new Set();

  generarColorFosforescenteOscuro(): string {
    let color: string;
    let attempts = 0; // Evita bucles infinitos

    do {
      // Colores base oscuros pero vibrantes
      const baseColors = [
        [180, 30, 30],  // Rojo profundo
        [30, 180, 30],  // Verde intenso
        [30, 30, 180],  // Azul eléctrico
        [160, 30, 160], // Púrpura oscuro
        [30, 160, 160], // Cian profundo
        [180, 100, 30]  // Naranja oscuro
      ];

      // Selecciona un color base aleatorio
      const base = baseColors[Math.floor(Math.random() * baseColors.length)];

      // Genera una variación fuerte dentro de un rango oscuro
      const r = Math.max(30, Math.min(200, base[0] + Math.floor(Math.random() * 80 - 40)));
      const g = Math.max(30, Math.min(200, base[1] + Math.floor(Math.random() * 80 - 40)));
      const b = Math.max(30, Math.min(200, base[2] + Math.floor(Math.random() * 80 - 40)));
      const alpha = 0.9;

      color = `rgba(${r}, ${g}, ${b}, ${alpha})`;
      attempts++;

      // Si se generan demasiados intentos sin éxito, se rompe el bucle
      if (attempts > 10) break;

    } while (this.usedColors.has(color)); // Verifica si ya existe en el historial

    // Agrega el color al historial para evitar duplicados
    this.usedColors.add(color);

    return color;
  }

  resetColors(): void {
    this.usedColors.clear(); // Limpia el historial si es necesario
  }



}


function chunkArray(array: any[], chunkSize: number): any[][] {
  const chunks = [];
  for (let i = 0; i < array.length; i += chunkSize) {
    chunks.push(array.slice(i, i + chunkSize));
  }
  return chunks;
}


const EARTH_RADIUS = 6371e3; // Radio de la Tierra en metros
const MAX_DISTANCE = 500; // Distancia máxima en metros para agrupar en una geozona



// 📌 Función para calcular la distancia entre dos puntos con la fórmula de Haversine
function haversineDistance(loc1: Location, loc2: Location): number {
  const R = 6371; // Radio de la Tierra en km
  const toRadians = (deg: number) => (deg * Math.PI) / 180;

  const dLat = toRadians(loc2.latitude - loc1.latitude);
  const dLon = toRadians(loc2.longitude - loc1.longitude);

  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(toRadians(loc1.latitude)) * Math.cos(toRadians(loc2.latitude)) *
    Math.sin(dLon / 2) * Math.sin(dLon / 2);

  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  return R * c; // Distancia en km
}

// 📌 Algoritmo de Dijkstra
function dijkstra(locations: Location[], startId: number): Map<number, number | null> {
  const distances = new Map<number, number>(); // Distancia mínima a cada nodo
  const previous = new Map<number, number | null>(); // Nodo anterior en la mejor ruta
  const unvisited = new Set<number>(); // Nodos no visitados

  // Inicializar todos los nodos con distancia infinita y sin predecesores
  locations.forEach(loc => {
    distances.set(loc.id, Infinity);
    previous.set(loc.id, null);
    unvisited.add(loc.id);
  });

  distances.set(startId, 0); // Nodo de inicio con distancia 0

  while (unvisited.size > 0) {
    // Encontrar el nodo no visitado con la menor distancia conocida
    let currentId: number | null = null;
    let minDistance = Infinity;

    for (const id of unvisited) {
      if (distances.get(id)! < minDistance) {
        minDistance = distances.get(id)!;
        currentId = id;
      }
    }

    if (currentId === null) break; // Si no hay nodo válido, salir del bucle

    unvisited.delete(currentId); // Marcar como visitado
    const currentLocation = locations.find(loc => loc.id === currentId);
    if (!currentLocation) continue;

    // Actualizar las distancias de los vecinos
    for (const neighbor of locations) {
      if (!unvisited.has(neighbor.id)) continue; // Ignorar nodos ya visitados

      const distance = haversineDistance(currentLocation, neighbor);
      const newDistance = distances.get(currentId)! + distance;

      if (newDistance < distances.get(neighbor.id)!) {
        distances.set(neighbor.id, newDistance);
        previous.set(neighbor.id, currentId);
      }
    }
  }

  return previous; // Retorna el mapa de rutas más cortas
}



export function groupLocationsByGeoZone(locations: Location[]): GeoZone[] {
  let geoZones: GeoZone[] = [];
  let zoneId = 1;

  locations.forEach(location => {
    let foundZone = false;

    for (let zone of geoZones) {
      if (zone.locations.some(loc => haversineDistance(loc, location) <= MAX_DISTANCE)) {
        zone.locations.push(location);
        foundZone = true;
        break;
      }
    }

    if (!foundZone) {
      geoZones.push({ id: zoneId++, locations: [location] });
    }
  });

  return geoZones;
}



function findOptimalRoute(locations: Location[]): Location[] {
  if (locations.length <= 1) return locations;

  const route: Location[] = [];
  const remaining = [...locations];

  // Iniciar desde el primer punto
  let current = remaining.shift()!;
  route.push(current);

  while (remaining.length > 0) {
    // Buscar el punto más cercano
    let nearestIndex = 0;
    let minDistance = haversineDistance(current, remaining[0]);

    for (let i = 1; i < remaining.length; i++) {
      const distance = haversineDistance(current, remaining[i]);
      if (distance < minDistance) {
        minDistance = distance;
        nearestIndex = i;
      }
    }

    // Mover el punto más cercano a la ruta
    current = remaining.splice(nearestIndex, 1)[0];
    route.push(current);
  }

  return route;
}





